/* eslint-disable arrow-body-style */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable camelcase */
/* eslint-disable no-warning-comments */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import { withRouter } from 'react-router-dom';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { formatCurrency, Tooltip, useModal } from '@jutro/components';
import { hideAll } from 'tippy.js';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { LoadSaveService, CustomQuoteService as GatewayCustomQuoteService } from 'gw-capability-gateway-quoteandbind';
import { MLAgentQuoteStickyComponent, MLQuotePageProposalComponent, MLUWIssuesPanelComponent, MLMinimumUnderlyingLimitModal, useMLLandingPageContext } from 'gw-capability-gateway-quoteandbind-common-react';
import { MLAgentQuoteStickyAutoComponent } from 'gw-capability-gateway-quoteandbind-pa-react';
import { QuotePageDriverTablesComponent } from 'gw-capability-quoteandbind-pa-react';
import { CustomQuoteService, MLPortalSettingsService } from 'gw-capability-quoteandbind';
import { UserService, MLOfferingService, MLHVQReverseFlowService, MLTransactionDiffService, MLProducerEligibilityService } from 'gw-capability-gateway';
import { MLPremiumUtil, MLProductCodeUtil, MLDisclosureUtil, MLLocalDateUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
import { MLStateRolloutService, MLBundleService, MLPortalStorageService, MLMultiLobsDataHolderService, MLHistoryService } from 'ml-services-common-react';
import {MLNotificationBlockUtil, MLWizardNavUtil} from 'ml-portals-util-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import {
    DriverExclusionAgreementPopup,
    DriverExclusionAgreementPopupMessages,
    DriverExclusionAgreementPopupStyles,
    RenameQuoteModalPopup,
    RenameQuoteModalPopupStyles
} from 'ml-capability-quoteandbind-common-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import _ from 'lodash';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import classNames from 'classnames';
import { MVR_ERR1, MVR_ERR2, MVR_ERR3 } from '../../../../override/constants/ml-mvr-constants';
import metadata from './GatewayQuotePage.metadata.json5';
import messages from './GatewayQuotePage.messages';
import styles from './GatewayQuotePage.module.scss';
import polDiscountsModalPopup from './PolicyDiscountsModalPopup.metadata.json5';
import emailAddressModalPopup from './EmailAddressModalPopup.metadata.json5';
import wizardConfig from "../../../gw-capability-gateway-quoteandbind-pa-react/config/pa-wizard-config.json5";
import hoWizardConfig from "../../../gw-capability-gateway-quoteandbind-ho-react/config/ho-wizard-config.json5"
import PATrackEvent from '../../components/TrackEvent/PATrackEvent';
import HOTrackEvent from '../../components/TrackEvent/HOTrackEvent';
import PUMBTrackEvent from '../../components/TrackEvent/PUMBTrackEvent';

import { Button, DropdownMenuButton } from '@jutro/legacy/components';

import { Link, DropdownMenuLink } from '@jutro/router';
import PeriodVersionDiffPopup from '../../components/PeriodVersionDiffPopup/PeriodVersionDiff';
import PeriodVersionDiffListPopup from '../../components/PeriodVersionDiffPopup/PeriodVersionDiffListPopup';

import { IntlContext } from '@jutro/legacy/locale';

const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';
const TERM_TYPE_HALF_YEAR = 'HalfYear';
const TERM_TYPE_7_DAY = '7Days';
const ratingPaymentMethodToAccountPaymentMethod = {
    'credit_debit_card': 'creditcard',
    'bank_account': 'ach',
    'mortgagee': 'responsive',
    'payroll_deduction': 'payrolldeduct_ml',
    'check': 'responsive'
};
const EMPTY_STRING = 'Empty';
const DEFAULT_TERM_MONTHS = 12;
const HALF_TERM_MONTHS = 6;
const isGPA = appConfig.portalCode === 'GPA';
const AUTO_BI_LIABILITY_LIMIT_WITH_PUP = ['zsujc1k1gme68blksm9t72h0hr8', 'zkijiqnckf5fl4rkbj9a1cg06ib', 'zehjibagknehd7m9o2uu80eq2ha'];
const AUTO_CSL_LIABILITY_LIMIT_WITH_PUP = ['z68imepl3af7e2oqp7a01nnap38', 'ziggu7q0oqh4helkporjetvjli8'];
const VT_AUTO_UMBI_LIABILITY_LIMIT_WITH_PUP = ['pack_212', 'z80jmastc76ilfprckb5emkm1ba', 'zsjh0m2725q1uc3g57a8sdc8399', 'z5th0lam22ik75ib5hk7fdk3qt9', 'zt2g4vj66qa0se9dj9tq7bcnvmb'];
const VT_AUTO_UMBI_LIABILITY_LIMIT_WITH_PUP_CSL = ['zsjh0m2725q1uc3g57a8sdc8399', 'z5th0lam22ik75ib5hk7fdk3qt9', 'zt2g4vj66qa0se9dj9tq7bcnvmb'];
const HOME_LIABILITY_LIMIT_WITH_PUP = ['zv2g2q9gnjtvs1frvs5k1clj3cb', 'zfli45ntnqpief5hi3r3pe3v609', 'zhvguctbr50qceq4ef05kavjnc9'];
const FUNCTIONAL_REPLACEMENT_COST_TERM_VALUE = 'Functional Replacement Cost';

const {
    ML_STORAGE_KEY_PREVIOUS_PREMIUM,
    MLUWIssuesBlockingPoints,
    MLCustomHistoryTypes
} = appConfig;

const {
    MLRatingForCheckPayment,
    MLRatingForAnnualPayment,
    MLRatingForMortgageePayment,
    MLRatingForMonthlyPayrollDeductPayment,
    MLRatingForBankAccountFullPayment,
    MLRatingForMonthlyPayment,
    MLRatingForBankAccountMonthlyPayment,
    MLRatingForCheckFullPayment
} = appConfig.mlRatingConfigs;

function GatewayQuotePage(props) {
    const modalApi = useModal();
    const {
        wizardData: submissionVM,
        updateWizardData,
        goNext,
        steps,
        jumpTo,
        history,
        currentStep,
        updateWizardSnapshot,
        changeNextSteps,
        isSkipping
    } = props;

    const {
        refreshOfferingsWithUserType,
        getAvailableOfferingsForProduct,
        getFirstAvailableOfferingForProduct
    } = MLOfferingService();

    const {
        showErrorModal,
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        clearBlockAlerts,
        clearManyBlockAlertsStartsWith,
        addErrorAlert,
        addWarningAlert,
        getNumberOfAlerts,
        addSuccessAlert,
        clearSuccessAlerts
    } = MLNotificationBlockUtil();

    const {nextStepVisited} = MLWizardNavUtil(props);
    const { steps: wizardSteps } = wizardConfig;
    const { steps: hoWizardSteps } = hoWizardConfig;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const { refreshData } = useDataRefresh();
    const { authHeader } = useAuthentication();
    const { updateWizardSubmission } = useMLLandingPageContext()

    const QUOTE_TAB_ID = 'quoteTab-';
    const offeredQuotesVmPath = 'quoteData.offeredQuotes.children';
    const offeredQuotesValuePath = 'quoteData.offeredQuotes.value';

    const [selectedQuoteIndex, setSelectedQuoteIndex] = useState(0);
    const [selectedQuoteVM, setSelectedQuoteVM] = useState(undefined);
    const [activeQuoteTab, setActiveQuoteTab] = useState(`${QUOTE_TAB_ID}${selectedQuoteIndex}quoteIterable`);

    const quoteID = _.get(submissionVM, 'quoteID.value');
    const forPostQuote = MLBundleService.isJobForPostQuote(quoteID);
    const isAlaska7Day = _.get(submissionVM, 'baseData.policyAddress.state.value') === 'AK' && _.get(submissionVM, 'baseData.termType.value') === '7Days';
    const isBookroll = ((_.get(submissionVM, 'bookrollInd_ML.value.code') === BOOKROLL_WITH_RATE_CAPPING) || (_.get(submissionVM, 'bookrollInd_ML.value.code') === BOOKROLL_WITHOUT_RATE_CAPPING));
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isBookrollBundleWithRateCapping = (_.get(submissionVM, 'bookrollInd_ML.value.code') === BOOKROLL_WITH_RATE_CAPPING);
    const isBookrollBundleWithoutRateCapping = (_.get(submissionVM, 'bookrollInd_ML.value.code') === BOOKROLL_WITHOUT_RATE_CAPPING);
    const isQuoteLocked = isBookrollBundleWithRateCapping || isAlaska7Day || (_.get(submissionVM, 'rateCapped_Ext.value'));

    const ratingPaymentMethodTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('RatingPaymentMethod_ML');
    const isBundle = _.get(submissionVM, 'isBundle_ML.value');

    const isCompRater = _.get(submissionVM, 'hvqQuoteID_ML.value');
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const hoCoveragePartType = _.get(submissionVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', '');
    const isPersonalAuto = MLProductCodeUtil.isPersonalAuto(productCode);
    const isHomeowners = MLProductCodeUtil.isHomeOwners(productCode);
    const isLandlordHome = submissionVM.value.isLandlordHome();
    const isLandlordCondo = submissionVM.value.isLandlordCondo();
    const isPersonalUmbrella = MLProductCodeUtil.isPersonalUmbrella(productCode);
    const isUMB_NP = isModernProduct && isPersonalUmbrella;
    const isRentPolicy = isHomeowners && hoCoveragePartType === 'hoprental';
    const sessionUUID = _.get(submissionVM, 'sessionUUID.value');
    const lobPathString = _.camelCase(_.get(submissionVM, 'baseData.productName.value', ''));
    const isAlaskaAutoFullTerm = _.get(submissionVM, 'baseData.policyAddress.state.value.code') === 'AK' && isPersonalAuto && _.get(submissionVM, 'baseData.termType.value.code') !== '7Days';
    const canShowPayrollDeduct = steps.findIndex((step) => step.mlStepName === 'paGroupAssociations' || step.mlStepName === 'hoGroupAssociations'
        || step.mlStepName === 'pupGroupAssociations' || step.mlStepName === 'compPaGroupAssociations' || step.mlStepName === 'compHoGroupAssociations') > -1;

    const [customQuotes, setCustomQuotes] = useState([]);
    const [customQuotesLoaded, setCustomQuotesLoaded] = useState(false);
    const [initialLoadCompleted, setInitialLoadCompleted] = useState(false);
    const [coverableStateLoaded, setCoverableStateLoaded] = useState(false);
    const [currentUser, setCurrentUser] = useState({});
    const [isPCSorIA, setIsPCSorIA] = useState(null);
    const [userPaymentPlans, setUserPaymentPlans] = useState([]);
    const [availableOfferings, setAvailableOfferings] = useState([]);
    const [isPurchasePolicyButton, setIsPurchasePolicyButton] = useState(false);
    const [isMainButtonClicked, setIsMainButtonClicked] = useState(false);
    const [isBundleWithPup, setIsBundleWithPup] = useState(false);
    const [showPupLiabilityLimitWarning, setShowPupLiabilityLimitWarning] = useState(false);
    const [canIssuePolicy, setCanIssuePolicy] = useState(false);
    const [userPermissionsLoaded, setUserPermissionsLoaded] = useState(false);
    const [stateIsQuoteBlockedByUwIssues, setStateIsQuoteBlockedByUwIssues] = useState(false);
    const [functionalReplacementCostError, setFunctionalReplacementCostError] = useState(false);
    const [isIncludedFeaturesVisible, setIsIncludedFeaturesVisible] = useState(false);
    const [showClueReportInfoLabel, setShowClueReportInfoLabel] = useState(false);
    const [isPUPPolicyRefreshed_Ext, setIsPUPPolicyRefreshed_Ext] = useState(false);
    const [isRequoteButtonClicked, setIsRequoteButtonClicked] = useState(false);
    const [underlyingPolicies, setUnderlyingPolicies] = useState(false);

    // PA Tabs State
    const [maxNumberVehiclesShown, setMaxNumberOfVehiclesShown] = useState(undefined);
    const [prevIndex, setPrevIndex] = useState(undefined);
    const [nextIndex, setNextIndex] = useState(undefined);
    const [isPrevAvailable, setIsPrevAvailable] = useState(undefined);
    const [isNextAvailable, setIsNextAvailable] = useState(undefined);
    const [lineCoverageNamesMap, setLineCoverageNamesMap] = useState([]);
    const [vehicleCoverageNamesMap, setVehicleCoverageNamesMap] = useState([]);
    const [optionalCoverageNamesMap, setOptionalCoverageNamesMap] = useState([]);
    const [coverablesToDisplay, setCoverablesToDisplay] = useState([]);
    const [termMonths, setTermMonths] = useState(undefined);
    const stateParams = _.get(history, 'location.state');
    const [currentPaymentPlan, setCurrentPaymentPlan] = useState({})
    const [offeredQuotes, setOfferedQuotes] = useState([]);
    const [versionDiff, setVersionDiff] = useState({});
    const [versionDiffTree, setVersionDiffTree] = useState({});
    const [isDiffPopupSelectorOpen, setIsDiffPopupSelectorOpen] = useState(false);
    const [isDiffPopupListOpen, setIsDiffPopupListOpen] = useState(false);
    const [isMultiVersionCompareEnabled, setIsMultiVersionCompareEnabled] = useState(true); 
    const [isProducerCodeUpdateToGroupID, setisProducerCodeUpdateToGroupID] = useState(false); 
    // Load offered quotes
    useEffect(() => {
        var offeredQuote = _.get(submissionVM, 'quoteData.offeredQuotes.value', [])
        setOfferedQuotes(offeredQuote.map(q => q.branchName))
        const diffData = {
            version1: undefined,
            version2: undefined,
            versionList1: [],
            versionList2: []
        };
        setVersionDiff(diffData);
        MLPortalSettingsService.getSettings(authHeader).then((response) => {
            if(response){
                setIsMultiVersionCompareEnabled(response.enableMultiVersionPortal);
            }
        })
    }, [
        JSON.stringify(_.get(submissionVM, 'quoteData.offeredQuotes.value', [])),
        authHeader
    ])

    useEffect(() => {
        MLPortalSettingsService.getSettings(authHeader).then((response)=> {
            if (response) {
                setisProducerCodeUpdateToGroupID(response.enableProducerCodeToGroupId_Ext)
            }
        });
    }, [authHeader]);

    const getQuoteIndexFromOfferings = useCallback((quote) => {
        const offerings = _.get(submissionVM, `${offeredQuotesValuePath}`, []);
        return offerings.findIndex((o) => o.publicID === quote.publicID);
    }, [submissionVM]);
    console.log("submissionVM",submissionVM)
    useEffect(() => {
      if (isPersonalAuto) {
        let policyDrivers = _.get(
          submissionVM,
          "lobData.personalAuto.coverables.drivers.value",
          []
        );
        filterDriverAndDisplayWarning(policyDrivers);
      }
      if (isPersonalUmbrella) {
        let vehicleOperators = _.get(
          submissionVM,
          "lobData.personalUmbrella.coverables.vehicleOperators.value",
          []
        );
        filterDriverAndDisplayWarning(vehicleOperators);
      }
    }, []);

    const filterDriverAndDisplayWarning = (policyDrivers) => {
        let maritalStatus = ["M", "C"];
        let pniStatus = policyDrivers.filter(
          (operator) =>
            (operator.relationshipToInsured === "self" || operator.relationshipToInsured_ML === "self") &&
            !maritalStatus.includes(operator.maritalStatus_Ext || operator.maritalStatus_ML)
        );
        let spouseStatus = policyDrivers.filter(
          (operator) =>
            (operator.relationshipToInsured === "spouse" || operator.relationshipToInsured_ML === "spouse") &&
            !maritalStatus.includes(operator.maritalStatus_Ext || operator.maritalStatus_ML)
        );
        if (pniStatus.length === 1 && spouseStatus.length === 1) {
          addWarningAlert(
            messages.maritalStatusRelationshipWarning,
            "maritalStatusRelationshipWarning"
          );
        }
    }

    const markQuoteStale = useCallback((_quoteVM = selectedQuoteVM) => {
        if (!_quoteVM.value.quoteStatus) {
            _quoteVM.value.quoteStatus = {};
        }
        _quoteVM.value.quoteStatus.isStale = true;
    }, [selectedQuoteVM]);

    const setValidationErrorAlerts = useCallback((errors, quoteVM) => {
        if (!_.isEmpty(errors)) {
            clearManyBlockAlertsStartsWith('validation-');
            let errorMessages = [];
            errors.forEach((error, index) => {
                errorMessages[index] = error;
            });
            _.uniq(errorMessages).forEach((error, index) => {
                const alertName = `validation-${index}`;
                setTimeout(() => addErrorAlert(error, alertName), 100);
                markQuoteStale(quoteVM);
            });
        }
    }, [addErrorAlert, clearManyBlockAlertsStartsWith, markQuoteStale]);

    const setPerilAlerts = useCallback((warnings) => {
        if (!_.isEmpty(warnings)) {
            if (warnings.includes("WindHail")) {
                addWarningAlert(messages.windstormHailDeductibleBumpedWarning, "windHail");
            }

            if (warnings.includes("MinRoofAge")) {
                addWarningAlert(messages.roofLossSettlementBumpedWarning, "roofLoss");
            }

            if (warnings.includes("AllOtherPeril")) {
                addWarningAlert(messages.allOtherPerilBumpedWarning, "allOtherPeril");
            }

            if (warnings.includes("GRCAvailable")) {
                addWarningAlert(messages.grcAvailableBumpedWarning, "grcAvailable");
            }
        }
    }, [addWarningAlert]);

    const updateBundleWidget = () => {
        setTimeout(() => {
            window.dispatchEvent(new Event('MLBundleWidget_updateJobs'));
        }, 100);
    };

    const isBlockingUWIssue = (uwIssue) => {
        return uwIssue.currentBlockingPoint !== MLUWIssuesBlockingPoints.NON_BLOCKING;
    };

    const toggleIncludedFeaturesSection = () => {
        setIsIncludedFeaturesVisible(!isIncludedFeaturesVisible);
    };

    const unblockNavigationForSelectedQuote = useCallback((quoteVM) => {
        const quote = quoteVM || selectedQuoteVM;
        const uwIssues = _.get(quote, 'value.uwIssues_ML', []);
        const hasBlockingIssues = uwIssues.some((uwIssue) => isBlockingUWIssue(uwIssue));
        _.set(submissionVM, 'value.blockNavigation_ML', hasBlockingIssues);
        refreshData();
    }, [selectedQuoteVM, submissionVM, refreshData]);

    const getQuoteCoverages = useCallback((quote) => {
        const offerings = _.get(submissionVM, `lobData.${lobPathString}.offerings.value`, []);
        const selectedOffering = offerings.find((o) => o.branchCode === quote.branchCode && o.branchPublicID === quote.publicID);
        return _.get(selectedOffering, 'coverages');
    }, [lobPathString, submissionVM]);

    const isSuspendLiabilitySelected = useCallback((quoteVM) => {
        const quote = quoteVM || selectedQuoteVM;
        const alertName = 'suspendLiabilitySelected';
        clearBlockAlerts(alertName);
        if (quote && quote.value && isPersonalAuto) {
            const currentCoverages = getQuoteCoverages(quote.value);
            currentCoverages.vehicleCoverages.forEach((vehicleCoverage) => {
                vehicleCoverage.coverages.forEach((coverage) => {
                    if (coverage.name === 'Suspend Liability' && coverage.selected === true && getNumberOfAlerts(alertName) <= 0) {
                        addWarningAlert(messages.suspendedLiability, alertName);
                        window.scrollTo(0, 0);
                    }
                });
            });
        }
    }, [getQuoteCoverages, isPersonalAuto, selectedQuoteVM, translator]); // eslint-disable-line react-hooks/exhaustive-deps

    const shouldShowPupLiabilityWarning = useCallback((quoteVM) => {
        const quote = quoteVM || selectedQuoteVM;
        if (isBundle && isBundleWithPup) {
            const chosenQuote = quote.value;
            const coverages = getQuoteCoverages(chosenQuote);
            if (isPersonalAuto) {
                const biLimit = _.find(coverages.lineCoverages, { code_ML: 'PALiabilityBICov_ML' });
                const cslLimit = _.find(coverages.lineCoverages, { code_ML: 'PALiabilityCSLCov_ML' });
                if (_.get(submissionVM, 'baseData.policyAddress.state.value.code') === 'VT') {
                    const umbiLimit = _.find(coverages.lineCoverages, { code_ML: 'PAUMBICov' });
                    const umbiTerm = _.find(umbiLimit.terms, { codeIdentifier_ML: 'PAUMBI' });
                    const showPupWarning = cslLimit?.terms.length > 0 ?
                        (AUTO_CSL_LIABILITY_LIMIT_WITH_PUP.indexOf(cslLimit.terms[0].chosenTerm) < 0 || VT_AUTO_UMBI_LIABILITY_LIMIT_WITH_PUP_CSL.indexOf(umbiTerm.chosenTerm) < 0) :
                        (AUTO_BI_LIABILITY_LIMIT_WITH_PUP.indexOf(biLimit.terms[0].chosenTerm) < 0 || VT_AUTO_UMBI_LIABILITY_LIMIT_WITH_PUP.indexOf(umbiTerm.chosenTerm) < 0);
                    setShowPupLiabilityLimitWarning(showPupWarning);
                } else {
                    const showPupWarning = cslLimit?.terms.length > 0 ? AUTO_CSL_LIABILITY_LIMIT_WITH_PUP.indexOf(cslLimit?.terms[0].chosenTerm) < 0 :
                        AUTO_BI_LIABILITY_LIMIT_WITH_PUP.indexOf(biLimit?.terms[0].chosenTerm) < 0;
                    setShowPupLiabilityLimitWarning(showPupWarning);
                }
            } else if (isHomeowners) {
                const hoLiabilityLimit = _.find(coverages.baseCoverages, { code_ML: 'HOPCovE' });
                if (!_.isUndefined(hoLiabilityLimit)) {
                    const chosenLimit = _.find(hoLiabilityLimit.terms, { codeIdentifier_ML: 'HOPCovELimit' });
                    const showPupWarning = HOME_LIABILITY_LIMIT_WITH_PUP.indexOf(chosenLimit.chosenTerm) < 0;
                    setShowPupLiabilityLimitWarning(showPupWarning);
                }
            }
        }
    }, [getQuoteCoverages, isBundle, isBundleWithPup, isHomeowners, isPersonalAuto, selectedQuoteVM, submissionVM]);

    const shouldTestFunctionalReplacementCost = (details) => {
        return details && details.yearBuilt < 1986 && details.isReplacementCostSelected_ML !== undefined;
    };

    const updateFunctionalReplacementCostWarning = useCallback((quoteVM) => {
        const quote = quoteVM || selectedQuoteVM;
        let showWarning = false;
        const constructionDetails = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.value');
        if ((isHomeowners || isLandlordHome) && shouldTestFunctionalReplacementCost(constructionDetails)) {
            const isDwellingReplacementCostSelected = constructionDetails.isReplacementCostSelected_ML;
            let isCoverageFunctionalReplacementCostSelected = false;

            if (quote && quote.value) {
                const currentCoverages = getQuoteCoverages(quote.value);
                currentCoverages.baseCoverages.forEach((basecoverage) => {
                    if (basecoverage.code_ML === 'HOPCovA') {
                        basecoverage.terms.forEach((hopcovaterm) => {
                            if ((hopcovaterm.codeIdentifier_ML === 'HOPCovAValuation') && (hopcovaterm.chosenTermValue === FUNCTIONAL_REPLACEMENT_COST_TERM_VALUE)) {
                                isCoverageFunctionalReplacementCostSelected = true;
                            }
                        });
                    }
                });
                showWarning = isDwellingReplacementCostSelected !== isCoverageFunctionalReplacementCostSelected;
            }
        }
        if (showWarning) {
            setFunctionalReplacementCostError(true);
            window.scrollTo(0, 0);
        } else {
            setFunctionalReplacementCostError(false);
        }
    }, [getQuoteCoverages, isHomeowners, isLandlordHome, selectedQuoteVM, submissionVM]);

    /*
    Existing function is modified to accept 2 optional params to support backwards compatibility
    Making useIndexApproach and quoteIdx optional params since setSelectedQuote is used in multiple places in this file
    and publicID approach is the fallback/default approach
    useIndexApproach -> boolean to determine if we use index based approach or publicID approach
    quoteIdx -> index of the quote tab to be selected -> default is null
    */
    const setSelectedQuote = useCallback((quoteVM, useIndexApproach = false, quoteIdx = null) => {
        const quoteIndex = getQuoteIndexFromOfferings(quoteVM.value);
        const selectedQuote = quoteVM.value;
        // pull validation error from the selectedQuote and dont persist across versions
        setValidationErrorAlerts(selectedQuote.validationErrors_ML, quoteVM);
        setSelectedQuoteVM(quoteVM);
        /*
        if useIndexApproach is true and quoteIdx is not null we will use quoteIdx to set the selected tab
        */
        if(useIndexApproach && quoteIdx !== null){
            setSelectedQuoteIndex(quoteIdx);
            setActiveQuoteTab(`${QUOTE_TAB_ID}${quoteIdx}quoteIterable`);
        }
        /*
        if useIndexApproach is false or quoteIdx is null we will use the existing publicID based approach
        */ 
        else{
            setSelectedQuoteIndex(quoteIndex);
            setActiveQuoteTab(`${QUOTE_TAB_ID}${quoteIndex}quoteIterable`);
        }
        // persist selection on the submission view model instead of sessionStorage
        _.set(submissionVM, 'bindData.value.chosenQuote', _.get(quoteVM, 'value.publicID'));
        if (typeof updateWizardData === 'function') {
            updateWizardData(submissionVM);
        }
        unblockNavigationForSelectedQuote(quoteVM);
        MLBundleService.setPremiumForJob(selectedQuote.quoteID, selectedQuote?.premium?.total);
        updateBundleWidget();
        isSuspendLiabilitySelected(quoteVM);
        hasITVWarningFunc(quoteVM);
        shouldShowPupLiabilityWarning(quoteVM);
        updateFunctionalReplacementCostWarning(quoteVM);
    }, [getQuoteIndexFromOfferings, setValidationErrorAlerts, setPerilAlerts, submissionVM.value.validationErrors_ML, updateWizardData]); // eslint-disable-line react-hooks/exhaustive-deps

    const refreshSelectedQuoteObj = useCallback((updatedQuote) => {
        // Clone Deep so dependencies on selectedQuoteObj are firing due to reference being changed
        const copy = viewModelService.clone(selectedQuoteVM);
        copy.value = updatedQuote;
        setSelectedQuoteVM(copy);

        // update customQuotes to reflects changes on components that uses customQuotes rather than selectedQuoteVM
        const quoteIdx = customQuotes.findIndex((qvM) => qvM.publicID.value === updatedQuote.publicID);

        const customQuotesCopy = [...customQuotes];
        if (quoteIdx >= 0) {
            Object.assign(customQuotesCopy[quoteIdx], updatedQuote);
            setCustomQuotes([...customQuotesCopy]);
        }
    }, [customQuotes, selectedQuoteVM, viewModelService]);


    const handleQuoteError = (error) => {
        hideProgressDialog();
        showErrorModal(messages.invalidQuote, messages.invalidQuoteErrorMsg);
        console.error('Error updating custom quote', error);
    };

    const navigateToStep = useCallback((pathToFind, data = {}) => {
        const indexOfStep = _.findIndex(
            steps,
            ({ path }) => path === pathToFind
        );
        if (!_.isEmpty(data)) {
            _.set(submissionVM, 'value.wizardActionDataML', data);
        }
        jumpTo(indexOfStep, data);
    }, [jumpTo, steps, submissionVM]);

    // Initialization fncs
    const hasOriginalNameFunc = (offering) => offering.branchName.lastIndexOf('(') > 0 && offering.branchName.lastIndexOf(')') > 0;


    const trimOfferingVersionNumber = (branchName) => {
        const hashIndex = branchName.lastIndexOf('#');
        return hashIndex > -1 ? branchName.substring(0, hashIndex - 1) : branchName;
    };

    const updateBindingData = useCallback((quote) => {
        const currentPaymentPlans = _.get(quote, 'paymentPlans_ML');
        const ratingPaymentMethod_ML = _.get(quote, 'ratingPaymentMethod_ML');
        if (currentPaymentPlans && currentPaymentPlans.length > 0) {
            const bindRatingPaymentMethod = _.get(submissionVM, 'bindData.paymentDetails.ratingPaymentMethod_ML');
            const selectedPaymentPlanBillingId = _.get(submissionVM, 'bindData.paymentDetails.selectedPaymentPlan_ML');
            const bindPaymentMethod = _.get(submissionVM, 'bindData.paymentDetails.paymentMethod');

            if (bindRatingPaymentMethod) {
                bindRatingPaymentMethod.value = ratingPaymentMethodTypelist.getCode(ratingPaymentMethod_ML);
            }

            if (selectedPaymentPlanBillingId
                && !currentPaymentPlans.some((plan) => plan.billingId === selectedPaymentPlanBillingId.value)) {
                selectedPaymentPlanBillingId.value = currentPaymentPlans[0].billingId;
            }
            if (bindPaymentMethod) {
                bindPaymentMethod.value = ratingPaymentMethodToAccountPaymentMethod[bindRatingPaymentMethod.value.code];
            }
        }
    }, [ratingPaymentMethodTypelist, submissionVM]);

    /**
    * Update the bindData payment details with up-to-date info based on the selectedQuote's chosen payment plan
    * This prevents the backend from resetting the payment plan and schedule to its default values
    */
    const refreshPaymentDetailsWithSelectedQuote = useCallback((quote) => {
        updateBindingData(quote);
        const promise = MLBundleService.setPremiumForJob(quoteID, _.get(quote, 'selectedPaymentPlan.total'));
        refreshData();
        updateBundleWidget();
        return promise
    }, [quoteID, refreshData, updateBindingData]);

    const isSamePaymentPlan = (pp1, pp2) => {
        return pp1.ratingPaymentMethod_ML === pp2.ratingPaymentMethod_ML
            && pp1.ratingPaymentSchedule_ML === pp2.ratingPaymentSchedule_ML;
    };

    const findAndMergePaymentPlan = useCallback((newPlan, availablePaymentPlans) => {
        let matchedPlan = availablePaymentPlans.find((existingPlan) => isSamePaymentPlan(existingPlan, newPlan));
        if (matchedPlan) {
            Object.assign(matchedPlan, newPlan);
        } else if (newPlan.paymentPlans?.[0]?.name !== 'Payroll Deduct') {
            availablePaymentPlans.push(newPlan);
            matchedPlan = newPlan;
        }
        return matchedPlan;
    }, [isSamePaymentPlan]);

    const resetPaymentPlans = useCallback((offering) => {
        offering.availablePaymentPlans = _.cloneDeep(userPaymentPlans);
        const selectablePaymentPlan = MLPremiumUtil.extractPremiumsForPaymentPlan(offering);
        selectablePaymentPlan.paymentPlans = offering.paymentPlans_ML;
        offering.selectedPaymentPlan = findAndMergePaymentPlan(selectablePaymentPlan, offering.availablePaymentPlans);
        return offering;
    }, [findAndMergePaymentPlan, userPaymentPlans]);

    const initAvailableOfferings = useCallback((user) => {
        const localProductCode = isHomeowners ? hoCoveragePartType : productCode;
        refreshOfferingsWithUserType(user.userType);
        if (isModernProduct && MLProductCodeUtil.isHomeOwnersPartialTypeHome(localProductCode)) {
            const offerings = getAvailableOfferingsForProduct('HOP_ModernProduct');
            setAvailableOfferings(offerings);
        }
        else if (isModernProduct && MLProductCodeUtil.isHomeOwnersPartialTypeCondo(localProductCode)) {
            const offerings = getAvailableOfferingsForProduct('HOPCondo_ModernProduct');
            setAvailableOfferings(offerings);
        }
        else if (isModernProduct && MLProductCodeUtil.isHomeOwnersPartialTypeRental(localProductCode)) {
            const offerings = getAvailableOfferingsForProduct('HOPRenters_ModernProduct');
            setAvailableOfferings(offerings);
        }
        else if (isModernProduct && MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(localProductCode)) {
            const offerings = getAvailableOfferingsForProduct('LLH_ModernProduct');
            setAvailableOfferings(offerings);
        }
        else if (isModernProduct && MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(localProductCode)) {
            const offerings = getAvailableOfferingsForProduct('LLC_ModernProduct');
            setAvailableOfferings(offerings);
        }
        else {
            const offerings = getAvailableOfferingsForProduct(localProductCode);
            setAvailableOfferings(offerings);
        }

    }, [getAvailableOfferingsForProduct, hoCoveragePartType, isHomeowners, productCode, refreshOfferingsWithUserType]);


    const initExtraDisplayQuoteData = useCallback((offeringVM, offeringCount, callSetSelectedQuote = true) => {
        console.log("Initial tab value is being set")
        const offering = offeringVM.value;
        if (offering.branchName) {
            const hasOriginalName = hasOriginalNameFunc(offering);
            offering.offeringLevel = hasOriginalName ? offering.branchName.substring(offering.branchName.lastIndexOf('(') + 1, offering.branchName.lastIndexOf(')')) : '';
            offering.displayBranchName = hasOriginalName ? offering.branchName.substring(0, offering.branchName.lastIndexOf('(') - 1) : trimOfferingVersionNumber(offering.branchName);
        }
        offering.isActive = false;
        resetPaymentPlans(offering);

        const isSelectedVersion = _.get(submissionVM, 'bindData.value.chosenQuote') === offering.publicID;
        if (offering.isSlotted_ML === true || isSelectedVersion || offeringCount === 1) {
            // avoid calling setSelectedQuote for multi version during initExtraDisplayQuoteData
            if(callSetSelectedQuote){
                setSelectedQuote(offeringVM);
            }
            _.set(submissionVM, 'bindData.value.chosenQuote', offering.publicID);
            refreshPaymentDetailsWithSelectedQuote(offering);
            offering.isActive = true;
        }
    }, [refreshPaymentDetailsWithSelectedQuote, resetPaymentPlans, setSelectedQuote, submissionVM]);

    const initForQuotedData = useCallback(() => {
        const offerings = _.get(submissionVM, offeredQuotesVmPath, []);
        // read persisted selection directly from the submission model (chosenQuote is a publicID)
        const chosenPublicID = _.get(submissionVM, 'bindData.value.chosenQuote');

        // If a chosen publicID exists, find its index among the offering VMs
        let matchedIndex = -1;
        if (chosenPublicID) {
            matchedIndex = offerings.findIndex((o) => _.get(o, 'value.publicID') === chosenPublicID);
        }

        // Initialize every offering (each call may call setSelectedQuote when conditions match)
        const initialized = offerings.map((offeringVM) => {
            // pass false to avoid multiple calls to setSelectedQuote during init
            initExtraDisplayQuoteData(offeringVM, offerings.length, false);
            return offeringVM;
        });

        // Ensure persisted selection is applied (in case initExtraDisplayQuoteData did not pick it)
        if (matchedIndex >= 0 && initialized[matchedIndex]) {
            // call setSelectedQuote to guarantee correct tab and side-effects
            setSelectedQuote(initialized[matchedIndex]);
        }

        return initialized;
    }, [initExtraDisplayQuoteData, submissionVM, setSelectedQuote]);

    const hasPolicyIssuePermission = useCallback(() => {
        UserService.hasUserSystemPermission({ permission: 'issue' }, authHeader)
            .then((canIssuePolicyRes) => {
                setCanIssuePolicy(canIssuePolicyRes);
                setUserPermissionsLoaded(true);
            });
    }, [authHeader]);

    const initCustomQuotes = useCallback(() => {
        setCustomQuotes(initForQuotedData());
        setCustomQuotesLoaded(true);
    }, [initForQuotedData]);

    const getAvailablePaymentPlanIDs = useCallback(() => {
        let paymentPlanIDs = [];
        if (isHomeowners && !isRentPolicy) {
            paymentPlanIDs = [
                MLRatingForBankAccountFullPayment,
                MLRatingForBankAccountMonthlyPayment,
                MLRatingForAnnualPayment,
                MLRatingForMonthlyPayment,
                MLRatingForMortgageePayment
            ];
        } else {
            paymentPlanIDs = [
                MLRatingForBankAccountFullPayment,
                MLRatingForBankAccountMonthlyPayment,
                MLRatingForAnnualPayment,
                MLRatingForMonthlyPayment
            ];
        }
        if (canShowPayrollDeduct && _.get(submissionVM, 'baseData.gafInfo_ML.payrollDeductAvailable.value', false) === true) {
            paymentPlanIDs.push(MLRatingForMonthlyPayrollDeductPayment);
        }

        paymentPlanIDs.push(MLRatingForCheckFullPayment);
        paymentPlanIDs.push(MLRatingForCheckPayment);
        return paymentPlanIDs;
    }, [isHomeowners, isRentPolicy, submissionVM]);


    const setAKAlerts = (isPCSorIA) => {
        if (isAlaska7Day) {
            if (isPCSorIA) {
                addWarningAlert(messages.ak7DayWarningAlertPCSIA, 'ak7Day');
            } else {
                addWarningAlert(messages.ak7DayWarningAlert, 'ak7Day');
            }
        }
        if (isAlaskaAutoFullTerm) {
            if (isPCSorIA) {
                addWarningAlert(messages.akAutoFullTermWarningAlertPCSIA, 'isAlaskaAutoFullTerm');
            } else {
                addWarningAlert(messages.akAutoFullTermWarningAlert, 'isAlaskaAutoFullTerm');
            }
        }
    };
    const allowFlowWithoutSignalNumber = (submissionData) => {
        let drivers = submissionData?.lobData?.personalAuto?.coverables?.drivers;
        if (Array.isArray(drivers)) {
            const targetCodes = [
                "PADriverSignalProgramPhoneNumber_Ext"
            ];

            drivers.forEach((driver) => {
                const modifiers = driver?.driverModifiers_ML?.modifiers;
                if (Array.isArray(modifiers)) {
                    modifiers.forEach((modifier) => {
                        if (modifier && targetCodes.includes(modifier.codeIdentifier_ML)) {
                            modifier.chosenTermValue = null;
                            modifier.isVisible_ML = false
                            modifier.isInputValueRequired_ML = false
                            modifier.editMode_ML = false
                            modifier.savedFromPortal = false
                        }
                    });
                }
            });
        }
    }

    // First Load to retrieve User and Payment Plans
    useEffect(() => {
        // Remove Group Data
        if (!canShowPayrollDeduct && submissionVM.baseData.gafInfo_ML.gpcCode && submissionVM.baseData.gafInfo_ML.gpcCode.value) {
            submissionVM.baseData.gafInfo_ML.value = undefined;
        }

        const initialLoad = () => {
            _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);

            if (currentStep.mlStepName === 'quoteCompRaterDetails') {
                if (updateWizardSubmission){
                    updateWizardSubmission(submissionVM)
                }
                MLMultiLobsDataHolderService.storeFlowSteps('quoteCompRaterDetails', 'quoteDetails', authHeader);
            }

            UserService.getCurrentUser(authHeader).then((user) => {
                setCurrentUser(user);
                setIsPCSorIA(user.isPCS || user.isIA);
                initAvailableOfferings(user);
                setUserPaymentPlans(getAvailablePaymentPlanIDs());
                MLTagManagerService.sendFormStepEvent('QuoteInfo', 'QuoteInfo_QuotePremium');

                const request = {
                    jobNumber: submissionVM.quoteID.value,
                    sessionUUID: submissionVM.sessionUUID.value,
                    eventType: MLCustomHistoryTypes.QuoteCompleted
                };
                MLHistoryService.createHistoryEvents([request], authHeader);

                hasPolicyIssuePermission();
                setInitialLoadCompleted(true);
                setAKAlerts(user.isPCS || user.isIA);
                const bumpedPerils = _.get(submissionVM, 'perilBumpedCoverages_Ext.value', []);
                setPerilAlerts(bumpedPerils);

                // Only show comprater message if this quote was bridged, and is eligible for the CR Wizard
                const isBridged = !_.isUndefined(_.get(submissionVM, 'hvqQuoteID_ML.value'));
                if (isBridged) {
                    MLStateRolloutService.checkIsCRWizardEligible(quoteID, authHeader).then((isCRWizardEligible) => {
                        clearSuccessAlerts();
                        if (isCRWizardEligible) {
                            setShowClueReportInfoLabel(true)
                        }
                    });
                }

                if (isBundle) {
                    MLBundleService.getBundleSummary(submissionVM.baseData.accountNumber.value, authHeader).then((sum) => {
                        setIsBundleWithPup(sum.jobSummaries.some((job) => {
                            return job.product.publicID === 'PersonalUmbrella';
                        }));
                        updateBundleWidget();
                    });
                }
            });
        };
        if (isGPA && submissionVM.baseData.status_ML.value === 'Quoted') {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Completed', isSkipping, submissionVM, user, { step: 'Quote Page',
                        total_Premium:`$${submissionVM.quoteData.value.offeredQuotes[0].premium?.total?.amount}`,
                        monthly_premium:`$${submissionVM.quoteData.value.offeredQuotes[0].premium?.monthlyPremium?.amount}` });
                }
                else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Completed', isSkipping, submissionVM, user, { step: 'Quote Page',
                        total_Premium:`$${submissionVM.quoteData.value.offeredQuotes[0].premium?.total?.amount}`,
                        monthly_premium:`$${submissionVM.quoteData.value.offeredQuotes[0].premium?.monthlyPremium?.amount}` });
                }
                else {
                    PATrackEvent('Quote Completed', isSkipping, submissionVM, user, { step: 'Quote Page',
                        total_Premium:`$${submissionVM.quoteData.value.offeredQuotes[0].premium?.total?.amount}`,
                        monthly_premium:`$${submissionVM.quoteData.value.offeredQuotes[0].premium?.monthlyPremium?.amount}` });
                }
            });
        }

        if (submissionVM.baseData.status_ML.value === 'Draft' || !MLLocalDateUtil.isEqual(submissionVM.baseData.value.periodStartDate, submissionVM.baseData.value.originalPeriodStartDate_ML) || submissionVM.value.forceRequote) {
            if (currentStep.mlStepName === 'quoteCompRaterDetails' && isPersonalAuto) {
                _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);
                allowFlowWithoutSignalNumber(submissionVM.value);
            }
            if (submissionVM?.isBundle_ML?.value && (MLBundleService.isJobForPostQuote(submissionVM.quoteID.value) || MLBundleService.isJobPostQuoteStarted(submissionVM.quoteID.value) || MLBundleService.isJobPostQuoteComplete(submissionVM.quoteID.value))) {
                // to remove it from purchase flow if it is Draft Status
                MLBundleService.resetPostQuoteStatusForJob(submissionVM.quoteID.value, authHeader)
                MLBundleService.resetPostQuoteStatusForAllJobs()
            }
            const quotePromise = LoadSaveService.saveAndQuoteSubmission(submissionVM.value, authHeader);
            showProgressDialog(messages.calculatingQuote, quotePromise);
            quotePromise.then((res) => {
                submissionVM.value = res;

                const quoteProductCode = _.get(submissionVM, 'value.baseData.productCode');

                if ((quoteProductCode === 'PersonalAuto' || quoteProductCode === 'HOPHomeowners') && _.get(submissionVM, 'value.hvqQuoteID_ML')) {

                    const stepsToComplete = [];

                    const stepsToIterate = quoteProductCode === 'PersonalAuto' ? wizardSteps : hoWizardSteps

                    for (const step of stepsToIterate) {
                        if (step.mlStepName === 'quoteDetails') {
                            break;
                        }

                        stepsToComplete.push(step.mlStepName);
                    }

                    MLMultiLobsDataHolderService.storeFlowStepsBulk(stepsToComplete, authHeader);
                }

                initialLoad();
            }).catch(error => {
                hideProgressDialog();
                if (
                  error.baseError &&
                  (error.baseError.includes(
                    MVR_ERR1,
                  ) ||
                    error.baseError.includes(
                      MVR_ERR2,
                    ) ||
                    error.baseError.includes(
                      MVR_ERR3,
                    ))
                ) {
                  addErrorAlert(
                    messages.mvrErrorMessage.defaultMessage,
                    "mvrError",
                  );
                } else {  
                  // US963261: Handle CDCE Exceptions error
                  MLErrorMessageUtil.handleException(
                    error,
                    showErrorModal,
                    messages.somethingWentWrong,
                  );
                }
            });
        } else {
            initialLoad();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // First Init after user loaded
    useEffect(() => {
        if (initialLoadCompleted) {
            initCustomQuotes();
            if (isGPA && !isSkipping) {
                UserService.getCurrentUser(authHeader).then((user) => {
                    if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                        HOTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Quote Page' });
                    }
                    else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                        PUMBTrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Quote Page' });
                    }
                    else {
                        PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Quote Page' });
                    }
                });
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialLoadCompleted]);

    useEffect(() => {
        setTimeout(()=>{
            const element = document.getElementById("quoteTab-0quoteIterable_50508372");
            if(element){
                element.focus();
            }
        }, 100)
  }, []);

    const isProducerAutoUpdatedFlag = _.get(submissionVM, 'baseData.producerAutoUpdated_Ext.value', false);

    useEffect(() => {
        if (isProducerAutoUpdatedFlag === true) {
            clearBlockAlerts('producercodechanged');
            addWarningAlert(messages.producerCodechangedWarning, 'producercodechanged');
        } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProducerAutoUpdatedFlag]);

    // Helper Funcs
    const isReadOnly = (quoteVM) => {
        return _.get(quoteVM, 'isReadOnlyML.value', false);
    };

    const hasValidationErrors = (quote) => {
        return _.get(quote, 'validationErrors_ML', []).length > 0;
    };

    const isQuoteSelectedQuote = useCallback((quote) => {
        return _.get(selectedQuoteVM, 'publicID.value') === quote.publicID;
    }, [selectedQuoteVM]);

    const formatAmountString = useCallback((value) => {
        const premium = _.get(value, 'amount', 0);
        const currency = _.get(value, 'currency', 'usd');
        try {
            return intl.formatNumber(premium, { style: 'currency', currency: currency });
        } catch (e) {
            return '';
        }
    }, [intl]);

    const getPerTermLabel = useCallback((selectedTermType) => {
        let label = translator(messages.perTermLabelYear);
        if (selectedTermType === TERM_TYPE_HALF_YEAR) {
            label = translator(messages.perTermLabel6Month);
        } else if (selectedTermType === TERM_TYPE_7_DAY) {
            label = translator(messages.perTermLabel7day);
        }
        return label;
    }, [translator]);

    const isQuotingInProgress = useCallback(() => {
        return _.get(selectedQuoteVM, 'value.quoteStatus.showLoading', false);
    }, [selectedQuoteVM]);

    const isSelectedQuoteStale = useCallback(() => {
        return _.get(selectedQuoteVM, 'value.quoteStatus.isStale', false) === true;
    }, [selectedQuoteVM]);

    const isSelectedQuoteCoverageMismatch = useCallback(() => {
        return _.get(selectedQuoteVM, 'value.quoteStatus.coverageMismatch', false) === true;
    }, [selectedQuoteVM]);

    const isPurchasePolicyAction = useCallback(() => {
        if (isQuotingInProgress()) {
            return false;
        }
        if (_.get(selectedQuoteVM, 'isReadOnlyML.value', false)) {
            return false;
        }
        if (_.get(selectedQuoteVM, 'value.quoteStatus.isStale', false) || _.get(selectedQuoteVM, 'value.status') === 'Draft') {
            return false;
        }
        if (isBundle) {
            return false;
        }
        return true;
    }, [isBundle, isQuotingInProgress, selectedQuoteVM]);

    const getNameForMainButton = useCallback(() => {
        if (isQuotingInProgress()) {
            return translator(messages.requoting);
        }
        if (_.get(selectedQuoteVM, 'isReadOnlyML.value', false)) {
            return translator(messages.continue);
        }
        if (_.get(selectedQuoteVM, 'value.quoteStatus.isStale', false) || _.get(selectedQuoteVM, 'value.status') === 'Draft') {
            setIsRequoteButtonClicked(true);
            return translator(messages.requote);
        }
        if (isBundle) {
            return forPostQuote && !stateParams?.returnToQuote ? translator(messages.continueToPurchase) : translator(messages.continue);
        }
        setIsPurchasePolicyButton(true);
        return translator(messages.purchasePolicy);
    }, [forPostQuote, isBundle, isQuotingInProgress, selectedQuoteVM, translator]);

    const isMainButtonDisabled = useCallback(() => {
        const isQuoteReadOnly = _.get(selectedQuoteVM, 'value.isReadOnlyML', false);
        const blockNavigation = _.get(submissionVM, 'value.blockNavigation_ML', false);
        const hasUIValidationError = selectedQuoteVM?.aspects?.subtreeValid === false;

        if (isBundle) {
            return isQuotingInProgress()
                || (blockNavigation && forPostQuote)
                || (isSelectedQuoteCoverageMismatch() || isQuoteReadOnly)
                || hasUIValidationError;
        }

        return isQuotingInProgress()
            || (!isSelectedQuoteStale() && blockNavigation)
            || (isSelectedQuoteCoverageMismatch() || isQuoteReadOnly)
            || isQuoteLocked
            || (isPurchasePolicyButton && (!canIssuePolicy && !isSelectedQuoteStale()))
            || (selectedQuoteVM && hasQuoteBlockingUWIssues(selectedQuoteVM.value.uwIssues_ML))
            || hasUIValidationError;
    }, [canIssuePolicy, forPostQuote, isBundle, isPurchasePolicyButton, isQuoteLocked, isQuotingInProgress,
        isSelectedQuoteCoverageMismatch, isSelectedQuoteStale, selectedQuoteVM, submissionVM]);


    const disableProposalFields = useCallback((quoteVM) => {
        return _.get(quoteVM, 'value.quoteStatus.showLoading', false) || forPostQuote || isQuoteLocked || isReadOnly(quoteVM);
    }, [forPostQuote, isQuoteLocked]);

    const syncEmailAddress = useCallback((emailAddress) => {
        _.set(submissionVM, 'bindData.contactEmail.value', emailAddress);
        _.set(submissionVM, 'baseData.accountHolder.emailAddress1.value', emailAddress);
        if (isPersonalAuto) {
            submissionVM.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
                if (driver.person.publicID === _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value.publicID')) {
                    driver.person.emailAddress_ML = emailAddress;
                }
            });
        }
        if(isPersonalUmbrella){
            submissionVM.value.lobData.personalUmbrella.coverables.vehicleOperators.forEach((operator) => {
                if(operator.contact.publicID === _.get(submissionVM, 'baseData.primaryNamedInsured_ML.value.publicID')) {
                    operator.emailAddress = emailAddress;
                }
            })
        }
        updateWizardData(submissionVM);
    }, [isPersonalAuto, isPersonalUmbrella, submissionVM, updateWizardData]);

    // Updates
    const updateQuoteVM = useCallback((quoteVM) => {
        const customQuotesCopy = [...customQuotes];
        /*
        F92616: Changing to use publicID instead of branchCode and BrancName
        Using branchCode and brancName was causing issues where multiple offerings of the same type existed
        */
        const updatedQuoteIndex = customQuotes.findIndex((o) => o.publicID.value === quoteVM.publicID.value);
        
        /*
        If updateQuoteIndex is found will update the existing quote and update the submissionVM
        else will push the new quote to the customQuotes array and update the submissionVM
        */
        if (updatedQuoteIndex >= 0) {
            // Update existing quote
            customQuotesCopy[updatedQuoteIndex] = quoteVM;
            setCustomQuotes(customQuotesCopy);
            setSelectedQuoteVM(quoteVM);

            _.set(submissionVM, `quoteData.offeredQuotes.value[${updatedQuoteIndex}]`, quoteVM.value);
            refreshData();
        } else {
            // Add new quote
            customQuotesCopy.push(quoteVM);
            setCustomQuotes(customQuotesCopy);
            setSelectedQuoteVM(quoteVM);

            // Add to submissionVM as well
            const offeredQuotes = _.get(submissionVM, 'quoteData.offeredQuotes.value', []);
            offeredQuotes.push(quoteVM.value);
            _.set(submissionVM, 'quoteData.offeredQuotes.value', offeredQuotes);
            refreshData();
        }
    }, [customQuotes, refreshData, submissionVM]);

    const getQuoteCoveragesVM = useCallback((quote) => {
        const offerings = _.get(submissionVM, `lobData.${lobPathString}.offerings.children`, []);
        const selectedOffering = offerings.find((o) => o.branchCode.value === quote.branchCode && o.branchName.value === quote.branchName);
        return _.get(selectedOffering, 'coverages');
    }, [lobPathString, submissionVM]);

    const createCustomQuoteRequest = useCallback((quote) => {
        const coverages = {
            [`${lobPathString}`]: getQuoteCoverages(quote)
        };

        const retRequest = {};
        retRequest.quote = quote;
        retRequest.sessionUUID = sessionUUID;
        retRequest.quoteID = quoteID;
        retRequest.ratingPaymentMethod_ML = quote.ratingPaymentMethod_ML;
        retRequest.ratingPaymentSchedule_ML = quote.ratingPaymentSchedule_ML;
        retRequest.productCode_ML = productCode;
        retRequest.forcePaymentMethodSelection_ML = true;
        retRequest.markAsSelectedVersion_ML = isQuoteSelectedQuote(quote);
        retRequest.coverages = coverages;

        return retRequest;
    }, [getQuoteCoverages, isQuoteSelectedQuote, lobPathString, productCode, quoteID, sessionUUID]);

    const updateCustomQuote = useCallback((quote, proposalCallback) => {
        const updateCustomQuoteRequest = createCustomQuoteRequest(quote);
        const updatePromise = GatewayCustomQuoteService.updateCustomQuote(updateCustomQuoteRequest, authHeader);
        showProgressDialog(platformMessages.updatingQuote, updatePromise);

        updatePromise.then((updatedCustomQuote) => {
            // TODO - Update Coverages with returned coverages
            quote.discounts_ML = updatedCustomQuote.discounts_ML;
            MLPremiumUtil.setPremiumsForQuote(quote, updatedCustomQuote.quote);
            quote.hasBlockingUWIssues = updatedCustomQuote.hasBlockingUWIssues;
            if (isQuoteSelectedQuote(quote)) {
                refreshPaymentDetailsWithSelectedQuote(updatedCustomQuote.paymentPlans_ML);
            }
            setIsPUPPolicyRefreshed_Ext(_.get(updatedCustomQuote, "isPUPPolicyRefreshed_Ext", false));
            if (proposalCallback) {
                const email = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value');
                proposalCallback(currentUser, quoteID, sessionUUID, email);
            }
        }, (error) => {
            console.error(error);
        });
        updatePromise.catch(handleQuoteError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authHeader, createCustomQuoteRequest, currentUser, isQuoteSelectedQuote, quoteID, refreshPaymentDetailsWithSelectedQuote, sessionUUID, showProgressDialog, submissionVM]);

    const createNewQuoteForOffering = useCallback((offering) => {
        const customQuoteDTO = {
            quote: selectedQuoteVM.value,
            sessionUUID: sessionUUID,
            quoteID: quoteID,
            offeringCode_ML: offering ? offering.code : null
        };

        // First generate new custom quote
        const createQuotePromise = CustomQuoteService.createQuoteForOffering(customQuoteDTO, authHeader);
        showProgressDialog(messages.creatingCustomQuotes);
        createQuotePromise.then((createdQuote) => {
            if (createdQuote) {
                const coverageRetrievalDTO = {
                    sessionUUID: sessionUUID,
                    quoteID: quoteID,
                    quoteBaseVersion_ML: createdQuote.publicID,
                    customizableQuote_ML: false
                };

                // Then retrieve coverages for new custom quote, and add new offering with coverages to submission
                CustomQuoteService.getCoverageLobsForOffering(coverageRetrievalDTO, authHeader)
                    .then((covs) => {
                        const lobCovs = _.get(covs, `${lobPathString}`, []);
                        const offerings = _.get(submissionVM, `lobData.${lobPathString}.offerings.value`, []);
                        const newOffering = {
                            branchCode: createdQuote.branchCode,
                            branchName: createdQuote.branchName,
                            branchPublicID: createdQuote.publicID,
                            coverages: lobCovs,
                            homeLosses_ML: createdQuote.homeLosses_ML
                        };
                        const offeringsCopy = [...offerings];
                        offeringsCopy.push(newOffering);
                        _.set(submissionVM, `lobData.${lobPathString}.offerings.value`, offeringsCopy);
                        if (isHomeowners) {
                            _.set(submissionVM, 'lobData.homeowners.coverables.disclosures_ML.losses.value', createdQuote.homeLosses_ML);
                        } else if (isPersonalUmbrella) {
                           _.set(submissionVM, 'lobData.personalUmbrella.coverables.homeLosses_ML.value', createdQuote.homeLosses_ML);
                        }
                        const createdQuoteVM = viewModelService.create(createdQuote, 'pc', 'edge.capabilities.policyjob.quoting.dto.OfferedQuoteDTO');
                        initExtraDisplayQuoteData(createdQuoteVM);
                        const customQuotesCopy = [...customQuotes];
                        customQuotesCopy.push(createdQuoteVM);
                        setCustomQuotes(customQuotesCopy);
                        submissionVM.quoteData.value.offeredQuotes.push(createdQuote);
                        updateWizardData(submissionVM);
                        setSelectedQuote(createdQuoteVM);
                        _.set(submissionVM, 'bindData.value.chosenQuote', createdQuoteVM.publicID.value);
                        setOfferedQuotes(prev => [...prev, createdQuote.branchName]);
                        hideProgressDialog();
                    });
            }
        }).catch(handleQuoteError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authHeader, customQuotes, hideProgressDialog, initExtraDisplayQuoteData, lobPathString, quoteID, selectedQuoteVM, sessionUUID, setSelectedQuote, showProgressDialog, submissionVM, updateWizardData, viewModelService]);

    const createNewQuote = useCallback(() => {
        if (isLandlordHome || isLandlordCondo) {
            createNewQuoteForOffering(getFirstAvailableOfferingForProduct(hoCoveragePartType));
        } else {
            createNewQuoteForOffering(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [createNewQuoteForOffering, hoCoveragePartType, isLandlordCondo, isLandlordHome]);


    const createEmailAddressModal = useCallback((quote) => {
        if (_.isNil(quote)) {
            quote = selectedQuoteVM.value;
        }
        const saveEmailAddress = () => {
            syncEmailAddress(_.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value'));
            const updateCustomQuoteRequest = createCustomQuoteRequest(quote);
            const updatePromise = GatewayCustomQuoteService.updatePolicyAccountHolderContact(updateCustomQuoteRequest, _.get(submissionVM, 'baseData.accountHolder.emailAddress1.value'), authHeader);
            showProgressDialog(messages.updatingAccountContact, updatePromise);
            return updatePromise.then((update) => {
                if (update) {
                    updateCustomQuote(quote);
                    if (isMainButtonClicked) {
                        setIsMainButtonClicked(false);
                        if (isPurchasePolicyAction()) {
                            showProducerAutoUpdatedAcknowledgementModal(() => {
                                mainButtonFunction();
                            });
                        } else {
                            mainButtonFunction();
                        }
                    }
                    return true;
                }

                showErrorModal(messages.error, messages.errorUpdatingContact);
            }, (error) => {
                console.error(error);
            });
        };

        const componentProps = {
            title: translator(messages.emailAddressRequired),
            uiProps: emailAddressModalPopup.pageContent,
            actionBtnLabel: messages.addEmail,
            cancelBtnLabel: messages.cancelModalBtn,
            onAsyncSaveAction: saveEmailAddress,
            overrideProps: {
                emailAddressField: {
                    label: translator(messages.emailAddress),
                    placeholder: translator(messages.yourEmailAddressHere),
                    required: _.isEmpty(_.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value'))
                }
            },
            viewModel: submissionVM,
            buttonType: 'outlined'
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).catch(() => {
            setIsMainButtonClicked(false);
            const emailAddress1 = _.get(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value');
            const isValidEmail =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1);
            if (!isValidEmail) {
                _.set(submissionVM, 'baseData.primaryNamedInsured_ML.emailAddress1.value', '');
                quote.commPreference_ML = 'paper';
                onDeliveryPreferenceChange(quote);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authHeader, createCustomQuoteRequest, isMainButtonClicked, selectedQuoteVM, showProgressDialog, submissionVM, syncEmailAddress, translator, updateCustomQuote]);

    // Email
    const onDeliveryPreferenceChange = useCallback((quote) => {
        if (quote) {
            _.set(submissionVM, 'baseData.policyBillingDocCommPref_ML.value', quote.commPreference_ML);
            if (quote.commPreference_ML === 'electronic' && _.isUndefined(_.get(submissionVM, 'bindData.contactEmail.value'))) {
                createEmailAddressModal(quote);
            } else {
                updateCustomQuote(quote);
            }
        }
    }, [createEmailAddressModal, submissionVM, updateCustomQuote]);

    const constructJsonQuoteObject = (quote) => {
        return {
            publicID: quote.publicID,
            monthlyPremium: quote.premium.monthlyPremium,
            total: quote.premium.total,
            branchCode: quote.branchCode
        };
    };

    const createUpdatePriorCarrierPremiumRequest = useCallback((quote) => {
        const retRequest = {};
        retRequest.quotePublicID = quote.publicID;
        retRequest.sessionUUID = sessionUUID;
        retRequest.quoteID = quoteID;

        retRequest.priorCarrierPremium_ML = _.get(submissionVM, 'baseData.priorCarrierPremium_ML.value');

        return retRequest;
    }, [quoteID, sessionUUID, submissionVM]);

    const hasQuotedOtherPaymentPlans = useCallback((chosenQuoteData) => {
        const paymentPlans = _.get(chosenQuoteData, 'availablePaymentPlans', []);
        return paymentPlans.every((paymentPlan) => !!paymentPlan.publicID);
    }, []);

    const hasQuotedChosenPaymentPlan_Ext = useCallback((chosenQuoteData) => {
        const index = chosenQuoteData?.availablePaymentPlans?.findIndex((paymentPlan) =>
            paymentPlan.ratingPaymentMethod_ML === chosenQuoteData.selectedPaymentPlan.ratingPaymentMethod_ML
            && paymentPlan.ratingPaymentSchedule_ML === chosenQuoteData.selectedPaymentPlan.ratingPaymentSchedule_ML
        );
        return !!chosenQuoteData.availablePaymentPlans[index].publicID;
    }, []);

    // Run Button Logic
    const clearValidationErrorMessages = useCallback(() => {
        selectedQuoteVM.value.validationErrors_ML = undefined;
        submissionVM.value.validationErrors_ML = undefined;
    }, [selectedQuoteVM, submissionVM]);

    const clearPerilAlerts = useCallback(() => {
        clearBlockAlerts('windHail');
        clearBlockAlerts('roofLoss');
        clearBlockAlerts('allOtherPeril');
        clearBlockAlerts('grcAvailable');
    }, [clearBlockAlerts]);

    // TODO : TA105643 : remove when PC rules are implemented
    const validatePANamedExclude = useCallback((callback) => {
        if (!isPersonalAuto) {
            return callback(true);
        }
        const currentCoverages = getQuoteCoverages(selectedQuoteVM.value);
        const vehicleCoverages = currentCoverages.vehicleCoverages;
        // named non owner / no vehicle
        if (!vehicleCoverages) {
            return callback(true);
        }

        let isValid = true;
        vehicleCoverages.forEach((vehCov) => {
            const alertName = `paNamedExclude${vehCov.fixedId}`;
            clearBlockAlerts(alertName);
            const paNamedExcludeAllSelectedMessage = {...messages.paNamedExcludeAllSelectedMessage, args: { vehicleName: vehCov.vehicleName }};
            const paNamedExcludeNoneSelectedMessage = {...messages.paNamedExcludeNoneSelectedMessage, args: { vehicleName: vehCov.vehicleName }};
            const selectedNamedExcludeCov = vehCov.coverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML' && cov.selected);
            if (selectedNamedExcludeCov) {
                const drivers = selectedNamedExcludeCov?.scheduledItems_ML?.excludeNamedDrivers;
                const driversSelected = drivers.filter((d) => d.driverExcluded);
                if (driversSelected.length === 0) {
                    addErrorAlert(paNamedExcludeNoneSelectedMessage, alertName);
                    isValid = false;
                }
                if (driversSelected.length === drivers.length) {
                    addErrorAlert(paNamedExcludeAllSelectedMessage, alertName);
                    isValid = false;
                }
            }
        });
        return callback(isValid);
    }, [getQuoteCoverages, isPersonalAuto, selectedQuoteVM, translator]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        updateFunctionalReplacementCostWarning();
    }, [updateFunctionalReplacementCostWarning]);

    const getITVValidation = useCallback((quoteVM) => {
        const quote = quoteVM || selectedQuoteVM;
        let hopCovAReplacementCost = false;
        let isITVInBetween80And100 = false;
        const currentCoverages = getQuoteCoverages(quote.value);
        currentCoverages.baseCoverages.forEach((basecoverage) => {
            if (basecoverage.code_ML === 'HOPCovA') {
                basecoverage.terms.forEach((hopcovaterm) => {
                    if ((hopcovaterm.codeIdentifier_ML === 'HOPCovAValuation') && (hopcovaterm.chosenTermValue === 'Replacement Cost')) {
                        hopCovAReplacementCost = true;
                    }
                    if ((hopcovaterm.codeIdentifier_ML === 'HOPCovALimit')) {
                        const hopCovAChosenTerm = hopcovaterm.chosenTermValue;
                        const hopCovAChosenTermValue = parseFloat(hopCovAChosenTerm.replace(/,/g, ''));
                        const replacementCostValue = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.replacementCost.amount.value', 0);
                        const itvpercent = ((hopCovAChosenTermValue / replacementCostValue) * 100);
                        if (itvpercent >= 80 && itvpercent < 100) {
                            isITVInBetween80And100 = true;
                        }
                    }
                });
            }
        });

        if ((hopCovAReplacementCost) === true && (isITVInBetween80And100 === true)) {
            return true;
        }
        return false;
    }, [getQuoteCoverages, selectedQuoteVM, submissionVM]);

    const hasITVWarningFunc = useCallback((quoteVM) => {
        let localHasWarning;
        if (isHomeowners && hoCoveragePartType === 'hopdwelling') {
            localHasWarning = getITVValidation(quoteVM);
        } else {
            localHasWarning = false;
        }
        if (localHasWarning) {
            if (getNumberOfAlerts('ITVError') <= 0) {
                addWarningAlert(messages.ITVAck, 'ITVError');
            }
        } else if (getNumberOfAlerts('ITVError') > 0) {
            clearBlockAlerts('ITVError');
        }
    }, [getITVValidation, hoCoveragePartType, isHomeowners]); // eslint-disable-line react-hooks/exhaustive-deps

    const clearValidationErrorAlerts = useCallback(() => {
        clearManyBlockAlertsStartsWith('validation-');
        clearValidationErrorMessages();
    }, [clearManyBlockAlertsStartsWith, clearValidationErrorMessages]);

    const savePremiumAndGoToNext = useCallback(() => {
        const offeredQuotes = [selectedQuoteVM.value];
        const jsonData = offeredQuotes.map((quote) => constructJsonQuoteObject(quote));
        MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM, JSON.stringify(jsonData), authHeader).then(() => {
            const request = {
                jobNumber: submissionVM.quoteID.value,
                sessionUUID: submissionVM.sessionUUID.value,
                eventType: MLCustomHistoryTypes.QuoteAccepted
            };
            MLHistoryService.createHistoryEvents([request], authHeader).then(() => {
                if (isPersonalAuto) {
                    if (MLDisclosureUtil.isRequotedAfterMvr(submissionVM.quoteID.value)) {
                        const index = _.findIndex(
                            steps,
                            ({ mlStepName }) => mlStepName === 'paVeracityCheck'
                        );
                        if (index > 0) {
                            const remainingSteps = _.slice(steps, index);
                            changeNextSteps(remainingSteps);
                        }
                        MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'paVeracityCheck', authHeader);
                    } else {
                        const hasAddtlInfoToBuyStep = steps.some((step) => step.mlStepName === 'paAddtlInfoToBuy');
                        if (!hasAddtlInfoToBuyStep) {
                            const addtlInfoToBuyIndex = _.findIndex(
                                wizardSteps, ({ mlStepName }) => mlStepName === 'paAddtlInfoToBuy'
                            );
                            const nextSteps = _.slice(wizardSteps, addtlInfoToBuyIndex);
                            changeNextSteps(nextSteps);
                        }
                        MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'paAddtlInfoToBuy', authHeader);
                    }
                }
                updateWizardSnapshot(submissionVM);
                goNext();
            });
        });
    }, [selectedQuoteVM, submissionVM, authHeader, isPersonalAuto, updateWizardSnapshot, goNext, steps, currentStep, changeNextSteps, wizardSteps]);

    const savePremiumforBundleQuote = useCallback(() => {
        const offeredQuotes = [selectedQuoteVM.value];
        const jsonData = offeredQuotes.map((quote) => {
            return constructJsonQuoteObject(quote);
        });
        MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM, JSON.stringify(jsonData), authHeader);
    }, [authHeader, selectedQuoteVM, submissionVM]);

    const consumeCallbacksSequentially = (callbackQueue, runOnCompletion, runOnError) => {
        if (callbackQueue.length > 0) {
            callbackQueue.shift()().then(
                () => consumeCallbacksSequentially(callbackQueue, runOnCompletion, runOnError),
                (err) => {
                    console.error(err);
                    if (runOnError) {
                        runOnError(err);
                    }
                });
        } else if (runOnCompletion) {
            runOnCompletion();
        }
    };

    const bundleExecuteAndExit = () => {
        if (isAlaska7Day || isBookroll) {
            MLTagManagerService.sendBundleFormCompleteEvent();
            history.push(`/agent-bundle-cart/${submissionVM.value.baseData.accountNumber}`);
            return;
        }

        const promise = new Promise((resolve, reject) => {
            const updateCallbackRequests = submissionVM.value.quoteData.offeredQuotes
                .map((quote) => {
                    const coverages = {
                        [`${lobPathString}`]: getQuoteCoverages(quote)
                    };
                    const updateCustomQuoteRequest = {
                        quote,
                        sessionUUID: submissionVM.value.sessionUUID,
                        quoteID: submissionVM.value.quoteID,
                        ratingPaymentMethod_ML: quote.ratingPaymentMethod_ML,
                        ratingPaymentSchedule_ML: quote.ratingPaymentSchedule_ML,
                        productCode_ML: submissionVM.value.baseData.productCode,
                        forcePaymentMethodSelection_ML: true,
                        markAsSelectedVersion_ML: quote.publicID === submissionVM.value.bindData.chosenQuote,
                        coverages : coverages
                    };
                    return () => CustomQuoteService.updateCustomQuote(updateCustomQuoteRequest, authHeader);
                });

            consumeCallbacksSequentially(
                updateCallbackRequests,
                () => resolve(submissionVM.value),
                (err) => reject(err)
            );
        });

        showProgressDialog(platformMessages.saveSubmission, promise);

        promise.then((submissionData) => {
            MLTagManagerService.sendBundleFormCompleteEvent();
            history.push(`/agent-bundle-cart/${submissionData.baseData.accountNumber}`);
        });
    };

    const handleRedirectionForBundle = async (isCRBridged) => {
        const quoteId = _.get(submissionVM, 'quoteID.value');
        const accountNumber = _.get(submissionVM, 'baseData.accountNumber.value');
        let quotesInBundle;
        if (isCRBridged) {
            quotesInBundle = await MLBundleService.checkIsCRBridgedQuote(quoteId, authHeader); // This return an array of submission in a bundle when it is CR Bridged
        } else  {
            quotesInBundle = await MLBundleService.getBundleSummary(accountNumber, authHeader);
            quotesInBundle = quotesInBundle.jobSummaries || [];
        }

        if(quotesInBundle && quotesInBundle.length > 0) {
            const agentBundleCartInfo = {
                accountNumber: submissionVM.value.baseData.accountNumber
            };

            // if all submissions have been quoted => redirect to Bundle Cart
            if(quotesInBundle.every((sub) => sub.totalPremium.amount !== 0)) {
                history.push(`/agent-bundle-cart/${submissionVM.value.baseData.accountNumber}`, agentBundleCartInfo);
            } else {
                // if has unquoted submission, jump to the next unquoted submission.
                let unquotedSubmission = quotesInBundle.filter((sub) => sub.status === 'Draft'); 
                if(unquotedSubmission.length > 0) {
                    if (unquotedSubmission.length === 1 && unquotedSubmission[0].jobNumber === quoteId) {
                        history.push(`/agent-bundle-cart/${submissionVM.value.baseData.accountNumber}`, agentBundleCartInfo);
                    } else {
                        // use the first unquoted submission
                        unquotedSubmission = unquotedSubmission[0];

                        const quoteEntryInfo = {
                            quoteID: unquotedSubmission.jobNumber,
                            postalCode: unquotedSubmission.address_ML.postalCode,
                            account: unquotedSubmission.accountNumber,
                            editBundle: true,
                            isBundle_ML: true,
                            hasExistingSubmissions_ML: true,
                            agentCompRaterStartEditingQuote: true,
                            editSubmissionFromBundle: true
                        };

                        MLBundleService.removePackageIndicatorRequoteJob(unquotedSubmission.publicID);
                        MLBundleService.markJobsForPrequote(true, authHeader);
                        history.push('/quoteentry', quoteEntryInfo);
                    }
                } else {
                    history.push(`/agent-bundle-cart/${submissionVM.value.baseData.accountNumber}`, agentBundleCartInfo);
                }
            } 
        }
    }

    const purchasePolicy = useCallback(() => {
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                if (submissionVM.baseData.productCode.value === 'HOPHomeowners') {
                    HOTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Quote Page', action: 'Quote Submitted' });
                }
                else if (submissionVM.baseData.productCode.value === 'PersonalUmbrella') {
                    PUMBTrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Quote Page', action: 'Quote Submitted' });
                }
                else {
                    PATrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Quote Page', action: 'Quote Submitted' });
                }
            });
        }
        const deviceRemovedPath = 'lobData.homeowners.coverables.constructionDetails_ML.isDeviceRemovedAlert_ML.value';

        if (isHomeowners && _.get(submissionVM, deviceRemovedPath, false)) {
            _.set(submissionVM, deviceRemovedPath, false);
        }

        if(isUMB_NP && validateUnboundAutoPolicy()) {
            return;
        }

        const updatePriorCarrierPremiumRequest = createUpdatePriorCarrierPremiumRequest(selectedQuoteVM.value);
        const updatePromise = GatewayCustomQuoteService.updatePriorCarrierPremium(updatePriorCarrierPremiumRequest, authHeader);
        updatePromise.then((result) => {
            if (!_.isUndefined(result) && result.amount !== '') {
                _.set(submissionVM, 'baseData.priorCarrierPremium_ML.value', result);
            }
            if (isBundle && !forPostQuote) {
                savePremiumforBundleQuote();
                bundleExecuteAndExit();
            } else {
                savePremiumAndGoToNext();
            }
        }, (error) => {
            console.error(error);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authHeader, createUpdatePriorCarrierPremiumRequest, forPostQuote, isBundle, isHomeowners, savePremiumAndGoToNext, savePremiumforBundleQuote, selectedQuoteVM, submissionVM]);

    

    // Payments
    const onQuotedPaymentPlan = useCallback((offering, createdQuote) => {
        const selectablePaymentPlan = MLPremiumUtil.extractPremiumsForPaymentPlan(createdQuote);
        selectablePaymentPlan.paymentPlans = createdQuote.paymentPlans_ML;
        findAndMergePaymentPlan(selectablePaymentPlan, offering.availablePaymentPlans);
    }, [findAndMergePaymentPlan]);


    const isPaymentPlanQuoted = useCallback((paymentPlan, paymentPlans) => {
        return paymentPlans.some((plan) => plan.publicID && isSamePaymentPlan(paymentPlan, plan));
    }, []);

    const markSelectedVersion_Ext = (paymentPlansToQuote, selectedPaymentPlan) => {
        const index = paymentPlansToQuote.findIndex((paymentPlan) =>
            paymentPlan.ratingPaymentMethod_ML === selectedPaymentPlan.ratingPaymentMethod_ML
            && paymentPlan.ratingPaymentSchedule_ML === selectedPaymentPlan.ratingPaymentSchedule_ML
        );
        return index;
    };

    const quotePaymentPlans = useCallback((paymentPlans, quote) => {
        return new Promise((resolve, reject) => {
            if (!quote.quoteStatus) {
                quote.quoteStatus = {
                    showLoading: true
                };
            } else {
                quote.quoteStatus.showLoading = true;
            }
            refreshSelectedQuoteObj(quote);
            const createdQuotes = [];
            // marking markAsSelectedVersion_ML as False to fetch QuotesForSpecifPaymentPlans on paymentplan change
            const paymentPlansToQuote = paymentPlans.map((item)=> ({...item,markAsSelectedVersion_ML:false}))
            paymentPlansToQuote[markSelectedVersion_Ext(paymentPlansToQuote, quote.selectedPaymentPlan)].markAsSelectedVersion_ML = true;
            const quotePromise = GatewayCustomQuoteService.requestQuotesForSpecifPaymentPlans(sessionUUID, quoteID, quote.publicID, paymentPlansToQuote, authHeader);
            showProgressDialog(platformMessages.updatingQuote, quotePromise);
            quotePromise.then((quotes) => {
                quotes.forEach((createdQuote) => {
                    onQuotedPaymentPlan(quote, createdQuote);

                if(isSamePaymentPlan(createdQuote, quote.selectedPaymentPlan) && createdQuote?.paymentPlans_ML?.length > 0) {
                    quote.selectedPaymentPlan.paymentPlans = createdQuote.paymentPlans_ML;
                }
                });
                createdQuotes.push(...quotes);
                quote.quoteStatus.showLoading = false;
                refreshSelectedQuoteObj(quote);
                resolve(createdQuotes);
            }).catch(error => {
                /* US1019684 Concurrent Data Change Exception on requote */
                  if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                      hideProgressDialog();
                      MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                      return false;
                  }
                  console.error(error);
                  quote.hasError = true;
                  quote.quoteStatus.showLoading = false;
                  refreshSelectedQuoteObj(quote);
                  reject(error);
            });
        });
    }, [authHeader, onQuotedPaymentPlan, quoteID, refreshSelectedQuoteObj, sessionUUID, showProgressDialog, isSamePaymentPlan]);

    const onUpdatedCustomQuote = (offering, createdQuote) => {
        resetPaymentPlans(offering);
        onQuotedPaymentPlan(offering, createdQuote);
        return offering;
    };

    const assignPaymentPlanIDAndQuote = useCallback((chosenQuoteData) => {
        return new Promise((resolve) => {
            const paymentPlanIDs = getAvailablePaymentPlanIDs();

            quotePaymentPlans(paymentPlanIDs, chosenQuoteData).then((createdQuotes) => {
                chosenQuoteData.others = createdQuotes;
                resolve(chosenQuoteData);
            });
        });
    }, [getAvailablePaymentPlanIDs, quotePaymentPlans]);

     // UW Issues Handling

    const isQuoteBlockingUWIssue = (uwIssue) => {
        return uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.BLOCKS_QUOTE;
    };

    const wasBlockingQuote = (uwIssue) => {
        return uwIssue.initialBlockingPoint_ML === MLUWIssuesBlockingPoints.BLOCKS_QUOTE;
    };

    const isRejectedUWIssue = (uwIssue) => {
        return uwIssue.hasApprovalOrRejection && uwIssue.currentBlockingPoint === MLUWIssuesBlockingPoints.REJECTED;
    };

    const hasQuoteBlockingUWIssues = useCallback((uwIssues) => {
        return uwIssues
            && uwIssues.some((uwIssue) => isQuoteBlockingUWIssue(uwIssue) || (wasBlockingQuote(uwIssue) && isRejectedUWIssue(uwIssue)));
    }, []);


    const updateQuotePayment = useCallback((selectedPaymentPlan) => {
        const onUpdatingPaymentPlan = (quote) => {
            quote.paymentPlans_ML = quote.selectedPaymentPlan.paymentPlans;
            quote.ratingPaymentSchedule_ML = quote.selectedPaymentPlan.ratingPaymentSchedule_ML;
            quote.ratingPaymentMethod_ML = quote.selectedPaymentPlan.ratingPaymentMethod_ML;
            if (quote.selectedPaymentPlan.discounts_ML === undefined) {
                const matchedPaymentPlan = quote.availablePaymentPlans?.find(
                    (paymentPlan) =>
                        paymentPlan?.ratingPaymentMethod_ML === quote.selectedPaymentPlan.ratingPaymentMethod_ML &&
                        paymentPlan?.ratingPaymentSchedule_ML === quote.selectedPaymentPlan.ratingPaymentSchedule_ML
                );

                quote.discounts_ML = matchedPaymentPlan?.discounts_ML ? matchedPaymentPlan?.discounts_ML : quote.selectedPaymentPlan.discounts_ML;
            } else {
                quote.discounts_ML = quote.selectedPaymentPlan.discounts_ML;
            }
            return refreshPaymentDetailsWithSelectedQuote(quote);
        };

        const quote = selectedQuoteVM.value;
        quote.selectedPaymentPlan = selectedPaymentPlan;
        if (!hasQuotedChosenPaymentPlan_Ext(quote)) {
         return  assignPaymentPlanIDAndQuote(quote).then((updatedQuote) => {
                return onUpdatingPaymentPlan(updatedQuote);
            });
        }
        return  onUpdatingPaymentPlan(quote);
        
    }, [assignPaymentPlanIDAndQuote, hasQuotedChosenPaymentPlan_Ext, refreshPaymentDetailsWithSelectedQuote, selectedQuoteVM]);

    const shouldShowDriverExclusionAgreement = useCallback(() => {
        // show if state is OR and there are excluded drivers on submission and modal has not been displayed already
        const policyStateCode = submissionVM.baseData.policyAddress.state.value.code;
        const isStateOR = (state) => state === 'OR';

        const policyDrivers = _.get(submissionVM,"lobData.personalAuto.coverables.drivers.value",[]);
        const hasExcludedDrivers = policyDrivers.filter((d) => d.type_ML === 'excluded')?.length > 0;

        return isStateOR(policyStateCode) && hasExcludedDrivers;
    }, [submissionVM]);

    const showDriverExclusionAgreementModal = useCallback(() => {
        const disableButton = () => {
            return _.get(submissionVM,"lobData.personalAuto.excludedDriverScriptAgree_Ext.value") === undefined;
        };

        const onSaveAction = async (subVM) => {
            const agree = subVM.lobData.personalAuto?.excludedDriverScriptAgree_Ext.value;
            if (agree === true) {
                // continue with excluded drivers
                goNext();
            } else {
                // change excluded drivers to non drivers and requote
                const policyDrivers = _.get(submissionVM,"lobData.personalAuto.coverables.drivers.value",[]);
                const excludedDrivers = policyDrivers.filter((d) => d.type_ML === 'excluded');
                excludedDrivers.forEach((driver) => {
                    driver.type_ML = 'nondriver';
                });

                showProgressDialog(messages.calculatingQuote);
                try {
                    await requoteSubmission();
                } catch (error) {
                    // do anything here?
                } finally {
                    hideProgressDialog();
                }
            }
        };

        const overrides = {
            descriptionText: {
                content: translator(DriverExclusionAgreementPopupMessages.driverExclusionAgreementPopupContent, {
                        li: (chunks) => <li>{chunks}</li>,
                        ol: (chunks) => <ol>{chunks}</ol>,
                        ratedPremium: formatCurrency(intl, {
                            value: selectedQuoteVM.premium?.ratedLiabilityPremium_Ext?.amount?.value,
                            currency: 'usd',
                            showFractions: false,
                            placeholder: '$0'
                        }),
                        excludedPremium: formatCurrency(intl, {
                            value: selectedQuoteVM.premium?.excludedLiabilityPremium_Ext?.amount?.value,
                            currency: 'usd',
                            showFractions: false,
                            placeholder: '$0'
                        })
                    }
                )
            }
        };

        const componentProps = {
            title: translator(DriverExclusionAgreementPopupMessages.driverExclusionAgreementPopupHeader),
            uiProps: DriverExclusionAgreementPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            cancelBtnLabel: platformMessages.mlCancel,
            viewModel: submissionVM,
            disableButton,
            modalBodyStyles: DriverExclusionAgreementPopupStyles,
            overrideProps: overrides,
            onSaveAction,
            showXCloseButton: true
        }

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(() => {
            return true;
        }).catch(() => {
            return false;
        });
    }, [authHeader, goNext, hideProgressDialog, modalApi, showProgressDialog, submissionVM, translator, updateWizardData]);

    const validateUninsuredMotoristLimit = () => {

        const policies = _.get(submissionVM,'lobData.personalUmbrella.underlyingPolicies.value',[]);
        const offerings = _.get(submissionVM,'lobData.personalUmbrella.offerings.value',[]);
    
        const isSelected = _.some(
            _.get(submissionVM,'lobData.personalUmbrella.offerings.value',[]),
            offering => _.some(
                _.get(offering,'coverages.prsnlAutoExcessCoverages',[]),
                coverage =>
                    coverage.code_ML === 'PUPExcessUninsuredUnderinsuredMotoristCov_Ext' && coverage.selected
            )
        );
 
        clearBlockAlerts('Uninsured Motorist Error');

        const hasMissingUninsuredMotoristLimit = _.some(policies, policy => {
            if (policy.policyType != 'PA' && policy.policyType != 'motorcycle_ml') {
                return false;
            }

            return _.some(offerings, offering => {
                const ulPolicyCoverages = _.get(offering, 'coverages.ulPolicyCoverages', []);

                return _.some(ulPolicyCoverages, ulPolicyCoverage => {
                    const coverages = _.get(ulPolicyCoverage, 'coverages', []);
                    return _.some(coverages, coverage => {
                        const uninsuredMotoristTerm = _.find(
                            coverage.terms,
                            term => term.name === 'Uninsured Motorist Limit'
                        );

                        if (isSelected && _.isEmpty(uninsuredMotoristTerm?.chosenTermValue)) {
                            return true;
                        }
                    });
                });
            });

        });

        if (hasMissingUninsuredMotoristLimit) {
            addErrorAlert(
                messages.uninsureMotoristLimit,
                'Uninsured Motorist Error'
            );
            window.scrollTo(0, 0);
            return true;
        }

        return false;
    };

    const validateUnboundAutoPolicy = () => {
        let ulPolicies;
        if(isRequoteButtonClicked) {
            ulPolicies = underlyingPolicies;
        } else {
            ulPolicies = _.get(submissionVM,'lobData.personalUmbrella.underlyingPolicies.value',[]);
        }

        const hasUnBoundPrefilledAuto = !isBundle
        && isUMB_NP
        && _.some(ulPolicies, (ulPolicy) => {
            const policyType = _.get(ulPolicy, 'policyType');
            const isExternal = _.get(ulPolicy, 'isExternal');
            const policyNumber = _.get(ulPolicy, 'policyNumber');

            return policyType === 'PA'
            && !isExternal
            &&  policyNumber === 'Unassigned'
        });

        if(hasUnBoundPrefilledAuto) {
            clearBlockAlerts('Bound Error');
            addErrorAlert(
                messages.autoBoundError,
                'Bound Error'
            );
            window.scrollTo(0, 0);
            return true;
        }

        return false;
    }
 

    const mainButtonFunction = useCallback( async() => {
        const isBundle = _.get(submissionVM, 'isBundle_ML.value');
        const isCRBridged = !_.isUndefined(_.get(submissionVM, 'hvqQuoteID_ML.value'));
        const isDraft = selectedQuoteVM.value.status === 'Draft';

        if(isUMB_NP && validateUninsuredMotoristLimit()) {
            return;
        }

        if (isBookrollBundleWithRateCapping) {
            savePremiumforBundleQuote();
            bundleExecuteAndExit();
        } else if (isSelectedQuoteStale() || hasValidationErrors(selectedQuoteVM.value) || isDraft) {
            clearValidationErrorAlerts();
            clearPerilAlerts();
            hasITVWarningFunc();
            updateFunctionalReplacementCostWarning();
            isSuspendLiabilitySelected();
            validatePANamedExclude(async (isValid) => {
                if (isValid) {
                    clearValidationErrorAlerts();
                    if (!_.isUndefined(selectedQuoteVM.value.updateQuote) && _.isFunction(selectedQuoteVM.value.updateQuote)) {
                        await selectedQuoteVM.value.updateQuote(submissionVM);
                        // To See if Payment Plan is Changed and also no validation issues were present before calling the paymentplan api
                        if(!_.isEmpty(currentPaymentPlan) && !selectedQuoteVM.value.hasError && !hasQuoteBlockingUWIssues()){
                            await updateQuotePayment(currentPaymentPlan);
                            setCurrentPaymentPlan({});
                            refreshData();
                        }
                    }
                } else {
                    window.scrollTo(0, 0);
                }
            });
        } else if (!isQuotingInProgress() && selectedQuoteVM.value.validateInputFields()) {
            clearValidationErrorAlerts();
            clearPerilAlerts();
            hasITVWarningFunc();
            updateFunctionalReplacementCostWarning();
            if (shouldShowDriverExclusionAgreement()) {
                showDriverExclusionAgreementModal();
            } else {
                validatePANamedExclude((isValid) => {
                    if (isValid) {
                        // US835669 - For bundle, go for redirection regardless is CompRater bridged or not
                        if (isBundle) {
                            handleRedirectionForBundle(isCRBridged);
                        } else {
                            purchasePolicy();
                        }
                    } else {
                        window.scrollTo(0, 0);
                    }
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearValidationErrorAlerts, clearPerilAlerts, hasITVWarningFunc, isBookroll, isQuotingInProgress, isSelectedQuoteStale, isSuspendLiabilitySelected, purchasePolicy, savePremiumforBundleQuote, selectedQuoteVM, submissionVM, updateFunctionalReplacementCostWarning, validatePANamedExclude]);

    // Rename Quote
    const canNameQuote = (quoteName, quote) => quoteName !== quote.branchName && quoteName.length > 0;

    const isQuoteNameRightLength = (quoteName) => quoteName.length > 0 && quoteName.length <= 60;

    const nameOrRenameQuote = useCallback((quote, index) => {
        if (isQuoteLocked) {
            return;
        }
        const vm = {
            quoteName: quote.branchName
        };

        const onNameThisQuote = (updatedVm) => {
            _.set(quote, 'branchName', updatedVm.quoteName);
            _.set(quote, 'displayBranchName', updatedVm.quoteName);
            _.set(submissionVM, `lobData.${lobPathString}.offerings.children.[${index}].branchName.value`, updatedVm.quoteName);
            return CustomQuoteService.setCustomQuoteVersionName(quote, sessionUUID, authHeader).then(() => {
                const customQuotesCopy = [...customQuotes];
                customQuotesCopy[index].value = quote;
                setCustomQuotes(customQuotesCopy);
                return true;
            });
        };

        const componentProps = {
            title: translator(messages.renameThisQuote),
            uiProps: RenameQuoteModalPopup.pageContent,
            actionBtnLabel: messages.saveModalBtn,
            cancelBtnLabel: messages.cancelModalBtn,
            modalBodyStyles: RenameQuoteModalPopupStyles,
            onSaveAction: onNameThisQuote,
            getOverrideProps: () => {
                return {
                    quoteNameErrorSpan: {
                        visible: !isQuoteNameRightLength(vm.quoteName)
                    }
                };
            },
            viewModel: vm,
            disableButton: () => !(canNameQuote(vm.quoteName, quote) && isQuoteNameRightLength(vm.quoteName)),
            buttonType: 'primary'
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, [authHeader, customQuotes, isQuoteLocked, sessionUUID, translator]);


    // PA Tab Section
    const isPrevButtonAvailable = useCallback((newIndex) => {
        if(!_.isUndefined(newIndex)) {
            return newIndex !== 0
        }

        return prevIndex !== 0;
    }, [prevIndex]);

    const isNextButtonAvailable = useCallback((newIndex) => {
        const coverages = getQuoteCoverages(selectedQuoteVM.value);

        if (newIndex) {
            return newIndex < coverages.vehicleCoverages.length;
        }

        return nextIndex < coverages.vehicleCoverages.length;
    }, [getQuoteCoverages, nextIndex, selectedQuoteVM]);

    const getCoverablesToDisplay = useCallback((start, end) => {
        const coverages = getQuoteCoverages(selectedQuoteVM.value);
        return coverages.vehicleCoverages.slice(start, end);
    }, [getQuoteCoverages, selectedQuoteVM]);

    const initCoverableToDisplay = useCallback(() => {
        setIsPrevAvailable(isPrevButtonAvailable());
        setIsNextAvailable(isNextButtonAvailable());
    }, [isNextButtonAvailable, isPrevButtonAvailable]);

    const findCoverageInMap = (coverageCode, map) => {
        return map.find((covInMap) => {
            return covInMap.coverageCode === coverageCode;
        });
    };

    const findTermInMap = useCallback((coverageCode, termCode, map) => {
        const coverage = findCoverageInMap(coverageCode, map);
        let isTermInMap = false;
        if (coverage) {
            isTermInMap = coverage.terms.find((termInMap) => {
                return termInMap.termCode === termCode;
            });
        }
        return isTermInMap;
    }, []);

    const extractTermNames = useCallback((coverage, map) => {
        coverage.terms.forEach((term) => {
            const covTermInMap = findTermInMap(coverage.publicID, term.patternCode, map);
            if (!covTermInMap) {
                if (term.name !== EMPTY_STRING) {
                    const coverageMap = findCoverageInMap(coverage.publicID, map);
                    coverageMap?.terms?.push({
                        termName: term.name,
                        termCode: term.patternCode,
                        isVisible_ML: term.isVisible_ML,
                        updated: !!term.updated
                    });
                }
            } else {
                covTermInMap.isVisible_ML = covTermInMap.isVisible_ML || term.isVisible_ML;
            }
        });
    }, [findTermInMap]);

    const createEmptyTermObjs = (numberOfTerms) => {
        const emptyTerms = [];
        const termObj = {
            isVisible_ML: true,
            isEditable_ML: false
        }
        for (let i = 0; numberOfTerms > i; i++) {
            emptyTerms.push(termObj);
        }
        return emptyTerms;
    };

    const addEmptyScheduleItemNames = useCallback((coverage, map) => {
        const excludeNamedDriverCov = coverage?.scheduledItems_ML?.excludeNamedDrivers;
        if (excludeNamedDriverCov && excludeNamedDriverCov.length > 0) {
            const coverageMap = findCoverageInMap(coverage.publicID, map);
            coverageMap.terms = createEmptyTermObjs(excludeNamedDriverCov.length);
        }
    }, []);

    const extractCoverageTermNames = useCallback((coverages, map) => {
        coverages.forEach((coverage) => {
            const covInMap = findCoverageInMap(coverage.publicID, map);
            if (!covInMap) {
                if (!(coverage.name === EMPTY_STRING || coverage.name.indexOf(`- ${EMPTY_STRING}`) > -1)) {
                    map.push({
                        coverageName: coverage.name,
                        coverageCode: coverage.publicID,
                        description: coverage.description,
                        required: coverage.required,
                        selected: coverage.selected,
                        terms: []
                    });
                }
            } else {
                covInMap.selected = coverage.selected;
            }

            if (coverage.terms && coverage.terms.length > 0) {
                extractTermNames(coverage, map);
            }
            if (!_.isEmpty(coverage?.scheduledItems_ML)) {
                addEmptyScheduleItemNames(coverage, map);
            }
        });
    }, [addEmptyScheduleItemNames, extractTermNames]);

    const createCoverageTitles = useCallback((localCoverablesToDisplay = coverablesToDisplay, localLineCoverageNamesMap = lineCoverageNamesMap, localVehicleCoverageNamesMap = vehicleCoverageNamesMap, localOptionalCoverageNamesMap = optionalCoverageNamesMap) => {
        const quote = selectedQuoteVM.value;
        const coverages = getQuoteCoverages(quote);
        extractCoverageTermNames(coverages.lineCoverages, localLineCoverageNamesMap);
        localCoverablesToDisplay.forEach((vehicleCov) => {
            extractCoverageTermNames(vehicleCov.coverages, localVehicleCoverageNamesMap);
        });
        extractCoverageTermNames(coverages.optionalCoverages_ML, localOptionalCoverageNamesMap);
    }, [coverablesToDisplay, extractCoverageTermNames, getQuoteCoverages, lineCoverageNamesMap, optionalCoverageNamesMap, selectedQuoteVM, vehicleCoverageNamesMap]);

    const sortCoverableCoverages = useCallback(() => {
        const quote = selectedQuoteVM.value;
        const coverages = getQuoteCoverages(quote);
        const sortedLineCoverages = _.sortBy(coverages.lineCoverages, 'name');
        const sortedOptionalCoverages = _.sortBy(coverages.optionalCoverages_ML, 'name');
        coverages.lineCoverages = sortedLineCoverages;
        coverages.optionalCoverages_ML = sortedOptionalCoverages;
        coverages.vehicleCoverages.forEach((vehicle) => {
            const sortedVehicleCoverages = _.sortBy(vehicle.coverages, 'name');
            vehicle.coverages = sortedVehicleCoverages;
            let sortedCoverageTerms = [];
            vehicle.coverages.forEach((coverage) => {
                sortedCoverageTerms = _.sortBy(coverage.terms, 'patternCode');
            });
            vehicle.coverages.terms = sortedCoverageTerms;
        });
    }, [getQuoteCoverages, selectedQuoteVM]);

    const createEmptyCoverageObject = useCallback((displayableCoverage) => {
        const retObj = {};
        retObj.name = `${displayableCoverage.coverageName} - ${EMPTY_STRING}`;
        retObj.publicID = displayableCoverage.coverageCode;
        retObj.coverageCode = displayableCoverage.coverageCode;
        retObj.terms = [];
        retObj.isEmpty = true;
        const termsLength = displayableCoverage.terms.length;
        if (termsLength > 0) {
            retObj.terms = createEmptyTermObjs(termsLength);
        }
        return retObj;
    }, []);

    const addEmptyCoverageObject = useCallback((coverages, displayableCoverage, index) => {
        const dummyCoverageObj = createEmptyCoverageObject(displayableCoverage);
        coverages.splice(index, 0, dummyCoverageObj);
    }, [createEmptyCoverageObject]);

    const areCoverageTermsEqual = (availableTerms, termsToCheck) => {
        let isEqual = true;
        // check per term
        availableTerms.forEach((availableTerm) => {
            if (!termsToCheck.find((term) => term.patternCode === availableTerm.termCode)) {
                isEqual = false;
            }
        });
        // check overall
        if (isEqual) {
            isEqual = availableTerms.length === termsToCheck.length;
        }

        return isEqual;
    };

    const createEmptyTermObjsForScheduleItem = (coverage, numberOfTerms) => {
        coverage.terms = [];
        for (let i = 0; numberOfTerms > i; i++) {
            const dummyTermObj = {
                name: EMPTY_STRING,
                isVisible_ML: true,
                updated: false
            };
            coverage.terms.push(dummyTermObj);
        }
    };

    const createEmptyTermObjsForDifference = (displayableCoverage, coverage) => {
        displayableCoverage.terms.forEach((displayableTerm, index) => {
            if (!coverage.terms.find((term) => term.patternCode === displayableTerm.termCode)) {
                const dummyTermObj = {
                    name: EMPTY_STRING,
                    patternCode: displayableTerm.termCode,
                    isVisible_ML: true,
                    updated: false
                };
                coverage.terms.splice(index, 0, dummyTermObj);
                coverage.terms.join();
            }
        });
    };

    const processSyncTerms = useCallback((vehicleCoverage, displayableCoverage, syncedCoverages) => {
        if (vehicleCoverage) {
            if (!areCoverageTermsEqual(displayableCoverage.terms, vehicleCoverage.terms) && _.isEmpty(vehicleCoverage?.scheduledItems_ML)) {
                createEmptyTermObjsForDifference(displayableCoverage, vehicleCoverage);
            }
            syncedCoverages.push(vehicleCoverage);
        }
    }, []);

    const syncScheduleItemTerms = useCallback((currentVehicle) => {
        const curExcludeNamedDriversCov = currentVehicle.syncedCoverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML');
        if (curExcludeNamedDriversCov && _.isEmpty(curExcludeNamedDriversCov?.scheduledItems_ML?.excludeNamedDrivers)) {
            // search vehicles that have PAExcludeNamedDriverVehicleLevel_ML which has excluded driverse
            const otherVehicles = coverablesToDisplay.filter((veh) => veh.fixedId !== currentVehicle.fixedId);
            const otherVehHaveScheduleItem = otherVehicles.find((veh) => {
                const excludeNamedDriverCov = veh.coverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML');
                const excludedDrivers = excludeNamedDriverCov?.scheduledItems_ML?.excludeNamedDrivers;
                return !_.isEmpty(excludedDrivers);
            });

            // add empty terms to coverage for missing schedule items
            if (otherVehHaveScheduleItem) {
                const excludeNamedDriverCov = otherVehHaveScheduleItem.coverages.find((cov) => cov.code_ML === 'PAExcludeNamedDriverVehicleLevel_ML');
                const numberOfDrivers = excludeNamedDriverCov?.scheduledItems_ML?.excludeNamedDrivers?.length;
                createEmptyTermObjsForScheduleItem(curExcludeNamedDriversCov, numberOfDrivers);
            }
        }
    }, [coverablesToDisplay]);

    const processSyncCoverages = useCallback((vehicle, localVehicleCoverageNamesMap) => {
        localVehicleCoverageNamesMap.forEach((displayableCoverage, index) => {
            const vehicleCoverage = vehicle.coverages.find((coverage) => coverage.publicID === displayableCoverage.coverageCode);
            if (!vehicleCoverage) {
                addEmptyCoverageObject(vehicle.syncedCoverages, displayableCoverage, index);
            } else {
                processSyncTerms(vehicleCoverage, displayableCoverage, vehicle.syncedCoverages);
            }
        });
        syncScheduleItemTerms(vehicle);
    }, [addEmptyCoverageObject, processSyncTerms, syncScheduleItemTerms]);

    const createCoverableCoverageMap = useCallback((localCoverablesToDisplay = coverablesToDisplay, localVehicleCoverageNamesMap = vehicleCoverageNamesMap) => {
        sortCoverableCoverages();
        localCoverablesToDisplay.forEach((vehicle) => {
            vehicle.syncedCoverages = [];
            processSyncCoverages(vehicle, localVehicleCoverageNamesMap);
        });
    }, [coverablesToDisplay, processSyncCoverages, sortCoverableCoverages, vehicleCoverageNamesMap]);

    const onPrevButtonClick = useCallback(() => {
        const newPrevIndex = prevIndex - 1;
        const newNextIndex = nextIndex - 1;
        setIsPrevAvailable(isPrevButtonAvailable(newPrevIndex));
        setIsNextAvailable(isNextButtonAvailable(newNextIndex));

        const newCoverablesToDisplay = getCoverablesToDisplay(newPrevIndex, newNextIndex);
        setCoverablesToDisplay(newCoverablesToDisplay);
        setPrevIndex(newPrevIndex);
        setNextIndex(newNextIndex);
        createCoverageTitles();
        createCoverableCoverageMap(newCoverablesToDisplay);
    }, [createCoverableCoverageMap, createCoverageTitles, getCoverablesToDisplay, isNextButtonAvailable, isPrevButtonAvailable, nextIndex, prevIndex]);

    const onNextButtonClick = useCallback(() => {
        const newPrevIndex = prevIndex + 1;
        const newNextIndex = nextIndex + 1;
        setIsPrevAvailable(isPrevButtonAvailable(newPrevIndex));
        setIsNextAvailable(isNextButtonAvailable(newNextIndex));

        const newCoverablesToDisplay = getCoverablesToDisplay(newPrevIndex, newNextIndex);
        setCoverablesToDisplay(newCoverablesToDisplay);
        setPrevIndex(newPrevIndex);
        setNextIndex(newNextIndex);
        createCoverageTitles();
        createCoverableCoverageMap(newCoverablesToDisplay);
    }, [createCoverableCoverageMap, createCoverageTitles, getCoverablesToDisplay, isNextButtonAvailable, isPrevButtonAvailable, nextIndex, prevIndex]);

    // Need to use local variables as state will not be updated yet
    const updateMaps = useCallback(() => {
        lineCoverageNamesMap.splice(0, lineCoverageNamesMap.length);
        vehicleCoverageNamesMap.splice(0, vehicleCoverageNamesMap.length);
        optionalCoverageNamesMap.splice(0, optionalCoverageNamesMap.length);
        const localCoverablesToDisplay = getCoverablesToDisplay(prevIndex, nextIndex);
        const allCoverables = getCoverablesToDisplay();

        initCoverableToDisplay();
        createCoverageTitles(allCoverables, lineCoverageNamesMap, vehicleCoverageNamesMap, optionalCoverageNamesMap);
        createCoverableCoverageMap(allCoverables, vehicleCoverageNamesMap);
        shouldShowPupLiabilityWarning();

        setLineCoverageNamesMap(_.sortBy(lineCoverageNamesMap, 'coverageName'));
        setVehicleCoverageNamesMap(_.sortBy(vehicleCoverageNamesMap, 'coverageName'));
        setOptionalCoverageNamesMap(_.sortBy(optionalCoverageNamesMap, 'coverageName'));
        setCoverablesToDisplay(localCoverablesToDisplay);
    }, [createCoverableCoverageMap, createCoverageTitles, getCoverablesToDisplay, initCoverableToDisplay, lineCoverageNamesMap, nextIndex, optionalCoverageNamesMap, prevIndex, shouldShowPupLiabilityWarning, vehicleCoverageNamesMap]);

    const setTermMonthsFunc = () => {
        const quote = selectedQuoteVM.value;
        const termType = quote.termType_ML ?? quote.termType;
        if (termType === TERM_TYPE_HALF_YEAR) {
            setTermMonths(HALF_TERM_MONTHS);
        } else {
            setTermMonths(DEFAULT_TERM_MONTHS);
        }
    };

    const hasCompraterPremiumChanged = () => {
        if (isCompRater && selectedQuoteVM && submissionVM) {
            return selectedQuoteVM.premium?.total?.amount?.value !== submissionVM.compRaterPremium_Ext?.amount?.value;
        }
        return false;
    };

    const showPremiumChangedAlert = useCallback(() => {
        if (((isPersonalAuto || isPersonalUmbrella) && MLDisclosureUtil.isRequotedAfterMvr(submissionVM.quoteID.value)) || hasCompraterPremiumChanged()) {
            if (getNumberOfAlerts('premiumChanged') <= 0) {
                addWarningAlert(messages.premiumChangedAfterVehicleMvrWarning, 'premiumChanged');
            }
        }
    }, [isPersonalAuto, isPersonalUmbrella, submissionVM.quoteID.value, hasCompraterPremiumChanged, getNumberOfAlerts, addWarningAlert]);


    useEffect(() => {
        if (isPersonalUmbrella || isHomeowners) {
            showPremiumChangedAlert();
        }
        if (!customQuotesLoaded || !isPersonalAuto) {
            return;
        }
        const quote = selectedQuoteVM.value;
        const maxNumberOfVehicles = 3;
        setMaxNumberOfVehiclesShown(maxNumberOfVehicles);
        setPrevIndex(0);
        const coverages = getQuoteCoverages(quote);
        setNextIndex(coverages.vehicleCoverages.length > 3 ? 3 : coverages.vehicleCoverages.length);
        setIsPrevAvailable(false);
        setIsNextAvailable(false);
        setLineCoverageNamesMap([]);
        setVehicleCoverageNamesMap([]);
        setOptionalCoverageNamesMap([]);
        setCoverablesToDisplay([]);
        setTermMonthsFunc();
        setCoverableStateLoaded(true);
        showPremiumChangedAlert();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customQuotesLoaded]);

    useEffect(() => {
        if (isBundle) {
            shouldShowPupLiabilityWarning();
        }
    }, [isBundle, isBundleWithPup, shouldShowPupLiabilityWarning]);

    // Wait for coverable state to be initialized before running maps update
    useEffect(() => {
        if (coverableStateLoaded && isPersonalAuto) {
            updateMaps();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coverableStateLoaded, selectedQuoteVM]);

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const isProducerAutoUpdated = useCallback(() => {
        return _.get(submissionVM, 'baseData.producerAutoUpdated_Ext.value', false) === true;
    }, [submissionVM]);

    const showProducerAutoUpdatedAcknowledgementModal = useCallback((onAcknowledge) => {
        // Run acknowledgement modal only when feature flag is enabled and producer code was auto-updated.
        if (!isProducerCodeUpdateToGroupID || !isProducerAutoUpdated()) {
            onAcknowledge();
            return;
        }

        const componentProps = {
            title: translator(messages.producerCodeAcknowledgementTitle),
            CustomComponent: () => <div>{translator(messages.producerCodechanged)}<br/><br/>{translator(messages.producerCodechangedAdditionalText)}<br/><br/>{translator(messages.producerCodechangedAssistanceText)}</div>,
            actionBtnLabel: translator(messages.acknowledgeAndContinue),
            cancelBtnLabel: translator(messages.cancelModalBtn),
            showFooterOnCustomComponent: true,
            showActionButton: true,
            onSaveAction: () => true
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(() => {
            onAcknowledge();
        }).catch(() => {});
    }, [isProducerAutoUpdated, isProducerCodeUpdateToGroupID, modalApi, translator]);

    const runMainButton = useCallback(() => {
        if (_.get(selectedQuoteVM, 'commPreference_ML.value.code') === 'electronic' && !_.get(submissionVM, 'bindData.contactEmail.value') && !isBookroll && !nextStepVisited()) {
            setIsMainButtonClicked(true);
            createEmailAddressModal();
        } else if (isPurchasePolicyAction()) {
            showProducerAutoUpdatedAcknowledgementModal(() => {
                mainButtonFunction();
            });
        } else {
            mainButtonFunction();
        }
    }, [createEmailAddressModal, isBookroll, isPurchasePolicyAction, mainButtonFunction, nextStepVisited, selectedQuoteVM, showProducerAutoUpdatedAcknowledgementModal, submissionVM]);


    const isQuoteBlockedByUWIssues = useCallback(() => {
        return hasQuoteBlockingUWIssues(submissionVM.value.uwIssues_ML);
    }, [hasQuoteBlockingUWIssues, submissionVM]);

    const requoteOffering = useCallback((publicID) => {
        let localQuote = selectedQuoteVM.value;
        if (publicID !== localQuote.publicID) {
            localQuote = customQuotes.find((qVM) => qVM.value.publicID === publicID);
            if (!localQuote) {
                console.error(new Error(`Could not requote quote with public ID ${publicID} since no quote was found`));
                return;
            }
            localQuote = localQuote.value;
        }
        const request = createCustomQuoteRequest(localQuote);
        const requotePromise = GatewayCustomQuoteService.requoteOffering(request, authHeader);
        showProgressDialog(messages.calculatingQuote, requotePromise);

        requotePromise.then((quoteResponse) => {
            const quoteIdx = customQuotes.findIndex((qvM) => qvM.publicID.value === quoteResponse.publicID);
            const quoteVM = viewModelService.create(quoteResponse, 'pc', 'edge.capabilities.policyjob.quoting.dto.OfferedQuoteDTO');
            initExtraDisplayQuoteData(quoteVM);

            const customQuotesCopy = [...customQuotes];
            if (quoteIdx >= 0) {
                customQuotesCopy[quoteIdx] = quoteVM;
            } else {
                console.warn('Offering requote did not find a matching quote to replace. It will be added as a new one');
                customQuotesCopy.push(quoteVM);
            }
            setCustomQuotes(customQuotesCopy);
            setSelectedQuote(quoteVM);
            const selectedQuoteOffering = _.get(submissionVM, 'quoteData.offeredQuotes.value', []);
            const indexOfCustomQuote = selectedQuoteOffering.findIndex((offeringQuote) => offeringQuote.publicID === quoteVM.value.publicID);
            _.set(submissionVM, `quoteData.offeredQuotes.value[${indexOfCustomQuote}]`, quoteVM.value);
            if (quoteVM.value.status === 'Quoted') {
                _.set(submissionVM, 'baseData.status_ML.value', 'Quoted');
            }
            updateWizardData(submissionVM);
            MLBundleService.setPremiumForJob(quoteVM.value.quoteID, quoteVM.value.total);
            updateBundleWidget();
        }, (error) => handleQuoteError(error));
        return requotePromise;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authHeader, createCustomQuoteRequest, customQuotes, initExtraDisplayQuoteData, selectedQuoteVM, setSelectedQuote, showProgressDialog, viewModelService]);

    const requoteSubmission = useCallback(() => {
        allowFlowWithoutSignalNumber(submissionVM.value);
        const saveAndQuotePromise = LoadSaveService.saveAndQuoteSubmission(submissionVM.value, authHeader);
        showProgressDialog(messages.calculatingQuote, saveAndQuotePromise);
        saveAndQuotePromise.then((qdd) => {
            // submissionVM.value = qdd;
            // updateWizardData(submissionVM);
            const newSubmissionVM = _.clone(submissionVM);
            _.set(newSubmissionVM, 'value', qdd);
            updateWizardData(newSubmissionVM);
            initCustomQuotes();
            showPremiumChangedAlert();
        });
        return saveAndQuotePromise;
    }, [authHeader, initCustomQuotes, showPremiumChangedAlert, showProgressDialog, submissionVM, updateWizardData]);


    const requote = useCallback((publicID) => {
        if (publicID) {
            const promise = requoteOffering(publicID);
            promise.then(() => unblockNavigationForSelectedQuote());
        } else if (stateIsQuoteBlockedByUwIssues) {
            requoteSubmission().then(() => {
                setStateIsQuoteBlockedByUwIssues(isQuoteBlockedByUWIssues());
            });
        }
    }, [isQuoteBlockedByUWIssues, requoteOffering, requoteSubmission, stateIsQuoteBlockedByUwIssues, unblockNavigationForSelectedQuote]);


    const approvedAllQuoteBlockingUwIssuesCallback = useCallback((publicID) => {
        requote(publicID);
    }, [requote]);

    const approvedAllBlockingUWIssuesCallback = useCallback((publicID) => {
        if (stateIsQuoteBlockedByUwIssues) {
            requote();
        } else if (publicID) {
            unblockNavigationForSelectedQuote();
        }
    }, [requote, stateIsQuoteBlockedByUwIssues, unblockNavigationForSelectedQuote]);

    const findQuote = useCallback((publicId) => {
        if (!customQuotes) {
            return null;
        }
        const foundQuoteVM = customQuotes.find((quoteVM) => {
            const quote = quoteVM.value;
            return quote.publicID === publicId;
        });
        return foundQuoteVM.value;
    }, [customQuotes]);

    const blockingUWIssuesPresentCallback = useCallback((publicID) => {
        if (selectedQuoteVM?.value.publicID === publicID && !submissionVM.value.blockNavigation_ML) {
            _.set(submissionVM, 'value.blockNavigation_ML', true);
            refreshData();
            console.warn('Navigation blocked due to new UW issues being present for selected quote');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [findQuote, selectedQuoteVM, submissionVM]);

    // TabSet
    const onQuoteTabChange = useCallback((tabId) => {
        if (tabId === 'addQuoteTabButton') {
            return;
        }

        const indexOfNumber = tabId.indexOf('-') + 1;

        const tabIndex = tabId.substring(indexOfNumber, tabId.indexOf('quoteIterable'));
        const newQuoteVM = customQuotes[tabIndex];

        newQuoteVM.value.isSelected = true;
        _.set(submissionVM, 'bindData.chosenQuote.value', newQuoteVM.value.publicID);
        const selectOfferingPromise = LoadSaveService.selectOffering(submissionVM.value, authHeader);
        showProgressDialog(platformMessages.updatingQuote, selectOfferingPromise);
        selectOfferingPromise.then((updatedSubmission) => {
            if (isHomeowners) {
                _.set(submissionVM, 'lobData.homeowners.coverables.disclosures_ML.losses.value', updatedSubmission.lobData.homeowners.coverables.disclosures_ML.losses);
            } else if (isPersonalUmbrella) {
                _.set(submissionVM, 'lobData.personalUmbrella.coverables.homeLosses_ML.value', updatedSubmission.lobData.personalUmbrella.coverables.homeLosses_ML);
            }
            /*
            If multi version compare is enabled
            when switching between quotes we need to update the coverables so going back to previous screens like drivers/vehicles for auto
            will show the correct data based on the selected version
            If Multi version compare is not enabled
            we still want to update the coverables for the selected version so there is not confusion for the agents
            */
            if (isPersonalAuto) {
              _.set(
                submissionVM,
                "lobData.personalAuto.coverables",
                updatedSubmission.lobData.personalAuto.coverables
              );
            } 
            if(isHomeowners) {
              _.set(
                submissionVM,
                "lobData.homeowners.coverables",
                updatedSubmission.lobData.homeowners.coverables
              );
            }
            updateWizardData(submissionVM);
            /*
            During tab switching instead of just passing the newQuoteVM also pass the tabIndex.
            This will ensure tabs are switchable even if there are 2 of the same offerings with same publicID
            */
            setSelectedQuote(newQuoteVM, true, tabIndex);
            if (tabIndex >= 0) {
                Object.assign(customQuotes[tabIndex], updatedSubmission);
                setCustomQuotes([...customQuotes]);
            }
        });
    }, [authHeader, customQuotes, isHomeowners, isPersonalAuto, isPersonalUmbrella, setSelectedQuote, showProgressDialog, submissionVM, updateWizardData]);

    const getAddQuoteTabContent = useCallback(() => {
        return (
            <div className={styles.addQuoteMenuContainer}>
                {availableOfferings.map((offering, idx) => {
                    return (
                        
                            <DropdownMenuLink 
                                tabindex="0"
                                onKeyDown={(evt) => {                                    
                                    const numOfferings = availableOfferings.length;                                    
                                    
                                    if(idx === 0 && evt.key === 'Tab' && evt.shiftKey) {
                                        document.getElementsByClassName('add-quote-button')[0].focus()
                                        evt.stopPropagation();
                                        evt.preventDefault();
                                    } else if (idx === numOfferings -1 && evt.key === 'Tab' && !evt.shiftKey) {
                                        document.getElementsByClassName('effective-date-focus-class')[0].firstChild.focus()
                                        evt.stopPropagation();
                                        evt.preventDefault();
                                    }
                                    
                                }}
                                onClick={() => {
                                    hideAll();
                                    createNewQuoteForOffering(offering);
                                }}
                            >
                                {offering.name}
                            </DropdownMenuLink>
                        
                    );
                })}
            </div>
        );
    }, [availableOfferings, createNewQuoteForOffering]);

    const getAddQuoteTabHeading = useCallback(() => {
         const isUmbOrLandlord = isPersonalUmbrella || isLandlordHome || isLandlordCondo;
         const isHomeOwnerandModernProduct = isModernProduct && isHomeowners;
        
        return ((!isUmbOrLandlord && !isModernProduct) || isHomeOwnerandModernProduct) ? (
            <DropdownMenuButton
                id="addQuoteScenarioDropdown"
                buttonText={translator(messages.addQuoteScenario)}
                icon="gw-keyboard-arrow-down"
                iconPosition="right"
                iconClassName={styles.addQuoteIcon} 
                toggleButtonClassName="add-quote-button"
                type="outlined"
                >
                    {getAddQuoteTabContent()}
            </DropdownMenuButton>
        ) :
            (
                <Button onClick={() => createNewQuote()} type="outlined">
                    {translator(messages.addQuoteScenario)}
                </Button>
            );
    }, [createNewQuote, getAddQuoteTabContent, isLandlordCondo, isLandlordHome, isPersonalUmbrella, translator]);

    const showCompareNowErrorModal = useCallback((error) => {
        console.error(error);
        const title = translator(messages.compareNowUnavailable);
        const description = translator(messages.compareNowUnavailableAtThisTime);
        showErrorModal(title, description, translator(messages.close));
    }, [showErrorModal, translator]);

    const getTabHeader = useCallback((quote, index) => {
        const isHomeOwnerandModernProduct = isModernProduct && isHomeowners;
        const displayBranchName = _.get(quote, 'value.displayBranchName', '')
        return (
            <div className={styles.tabHeading}>
                <div className={classNames(styles.noPadding, 'nav-tabs__text text-align-left')}>
                    <div className="display-flex">
                        <div className={classNames(styles.tabsTextQuoteName, 'nav-tabs__text-header pull-left')}>
                            {(isModernProduct && displayBranchName === "Recommended") ? "" : displayBranchName}#{index + 1}
                        </div>
                        {!isReadOnly(quote) && (
                            <span className={forPostQuote ? 'no-pointer-event text-link link-rename pull-right' : 'has-pointer-event text-link link-rename pull-right'} onClick={() => nameOrRenameQuote(quote.value, index)}>
                                {translator(messages.rename)}
                            </span>
                        )}
                    </div>
                    {!isAlaska7Day && (
                        <span className={(_.get(quote, 'value.quoteStatus.isStale', false) || hasValidationErrors(quote.value)) && !isBookroll ? 'strikethrough nav-tabs__text-subtext pull-left' : 'nav-tabs__text-subtext pull-left'}>
                            <span>
                                {formatAmountString(_.get(quote, 'value.selectedPaymentPlan.monthlyPremium'))}/{translator(messages.perMonth)}
                            </span>
                            <br />
                            <span>
                                {formatAmountString(_.get(quote, 'value.selectedPaymentPlan.total'))}/{getPerTermLabel(_.get(quote, 'value.termType_ML'))}
                            </span>
                        </span>
                    )}
                    {isAlaska7Day && (
                        <span className="nav-tabs__text-subtext pull-left">
                            {formatAmountString(_.get(quote, 'value.selectedPaymentPlan.total'))}/{getPerTermLabel(_.get(quote, 'value.termType_ML'))}
                        </span>
                    )}
                    {_.get(quote, 'value.quoteStatus.showLoading', false) && (
                        <img src="/throbber.gif" alt="Loading" />
                    )}
                </div>
            </div>
        );
    }, [forPostQuote, formatAmountString, getPerTermLabel, isAlaska7Day, isBookroll, nameOrRenameQuote, translator]);

    const openMinimumLiabilityModal = () => {
        const componentProps = {
            title: messages.requiredMinimumUnderlyingInsurance,
            CustomComponent: MLMinimumUnderlyingLimitModal,
            actionBtnLabel: commonMessages.close,
            showFooterOnCustomComponent: true
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const getLiabilityLimitWarningMessageContent = () => {
        return (
            translator(messages.pupLiabilityLimitsWarning, {
                a: (chunks) => <a role="button" tabIndex={0} onClick={openMinimumLiabilityModal} onKeyDown={openMinimumLiabilityModal}>{chunks}</a>
            })
        );
    };

    const isCompareNowVisible = () => {
        const isMonoline = !MLMultiLobsDataHolderService.hasMultiJobs();
        const isPAOrHO = submissionVM.value.isHomeOwners() || submissionVM.value.isPersonalAuto();
        return isMonoline && !isBundle
            && isPAOrHO
            && currentUser.isChoiceAgent_ML
            && !isQuoteLocked;
    };

    const addBannerMessage = (type, message) => {
        switch(type) {
            case 'error':
                addErrorAlert(message, "mvrError");
                break;
            case 'warning':
                addWarningAlert(message, "mvrWarning");
                break;
            case 'success':
                addSuccessAlert(message, "mvrSuccess");
                break;
            case 'warningPending':
                addWarningAlert(message, "mvrWarningPending");
                break;
            default:
                break;
        }
    };

    const removeBannerMessage = () => {
        clearBlockAlerts("mvrError");
        clearBlockAlerts("mvrWarning");
        clearBlockAlerts("mvrSuccess");
        clearBlockAlerts("mvrWarningPending");
    };

    const returnToActivityPage = () => {
        const indexOfQuoteDetailsPage = _.findIndex(steps, ({ path }) => path === '/disclosure-to-quote');
        MLDisclosureUtil.setManualOrderMvr(quoteID, true)
        MLDisclosureUtil.setAssignedViolationsForQuote(quoteID, true)
        jumpTo(indexOfQuoteDetailsPage);
    };

    const hasAnyNonApprovedUwIssue = (quoteVM) => {
        const uwIssues = _.get(quoteVM, 'value.uwIssues_ML');
        if (uwIssues && uwIssues.length > 0) {
            return uwIssues.some(elem => elem.hasApprovalOrRejection === false && elem.initialBlockingPoint_ML !== 'NonBlocking')
        }

        return false;
    };

    const onCompareVersionClick = () => {
        const newData = versionDiff
        if(versionDiff.versionList1.length === 0){
            newData.versionList1 = offeredQuotes
            newData.version1 = offeredQuotes[0]
            newData.versionList2 = offeredQuotes
        }
        setVersionDiff(newData)
        setIsDiffPopupSelectorOpen(true)
    }

    const getVersionDiffPopup = () => {
      const getDiff = (data) => {
        return MLTransactionDiffService.getDiffBetweenVersions(
          quoteID,
          data.version1Index,
          data.version2Index,
          authHeader
        );
      };

      const onClickDiffButton = async (data) => {
        const diff = await getDiff(data);
        setVersionDiffTree(diff);
        setIsDiffPopupSelectorOpen(false);
        setIsDiffPopupListOpen(true);
      };

      if (isDiffPopupSelectorOpen) {
        const componentProps = {
          data: versionDiff,
          // policyNumber: policyNumber,
          onSaveAction: (data) => onClickDiffButton(data),
          isOpen: isDiffPopupSelectorOpen,
          onReject: () => setIsDiffPopupSelectorOpen(false),
          onResolve: () => setIsDiffPopupSelectorOpen(false),
        };
        return <PeriodVersionDiffPopup {...componentProps} />;
      }
      return null;
    };

    const getVersionDiffListPopup = () => {
      const componentProps = {
        transactions: versionDiffTree.versions,
        diff: versionDiffTree.diffNodes,
        isOpen: isDiffPopupListOpen,
        onReject: () => setIsDiffPopupListOpen(false),
      };
      return <PeriodVersionDiffListPopup {...componentProps} />;
    };

    const isOECWarningAvailable = () =>{

        const isColoradoState = _.get(submissionVM ,'baseData.policyAddress.state.value.code') === "CO"
        if(isPersonalAuto && isCompRater && isColoradoState){
            return true
        }

        return false
    }

    const isAnnualTermEligibleInfoAvailable = useCallback(() => {
        return _.get(selectedQuoteVM, 'isAnnualTermEligible.value', false);
    }, [selectedQuoteVM])


    const generateQuoteOverrides = useCallback(() => {
        const quoteOverrides = customQuotes.map((quoteVM, index) => {
            return {
                [`${QUOTE_TAB_ID}${index}`]: {
                    heading: getTabHeader(quoteVM, index),
                    className: 'tab'
                },
                [`pupLiabilityLimitWarning${index}`]: {
                    visible: !!showPupLiabilityLimitWarning,
                    message: getLiabilityLimitWarningMessageContent()
                },
                [`pupUnderlyingPoliciesSynchedInfo${index}`]: {
                    visible: _.get(submissionVM, "value.isPUPPolicyRefreshed_Ext", false) || isPUPPolicyRefreshed_Ext
                },
                [`proposalSectionComponent${index}`]: {
                    submissionVM,
                    quoteVM,
                    isAlaska7Day,
                    hasValidationErrors,
                    isBookroll,
                    isBookrollBundleWithRateCapping,
                    getPerTermLabel,
                    getNameForMainButton,
                    runMainButton,
                    disableProposalFields,
                    updateQuoteVM,
                    updateQuotePayment,
                    updateCustomQuote,
                    markQuoteStale,
                    currentUser,
                    isMainButtonDisabled,
                    onDeliveryPreferenceChange,
                    history,
                    addBannerMessage,
                    removeBannerMessage,
                    returnToActivityPage,
                    uwIssuesExist: hasAnyNonApprovedUwIssue(quoteVM),
                    showClueReportInfoLabel,
                    hasQuoteBlockingUWIssues: hasQuoteBlockingUWIssues(quoteVM.value.uwIssues_ML),
                    isSelectedQuoteStale,
                    setCurrentPaymentPlan,
                    currentPaymentPlan
                },
                [`includedFeaturesSection${index}`]: {
                    visible: !isPersonalUmbrella && !isPersonalAuto
                },
                [`includedFeaturesComponent${index}`]: {
                    visible: isPersonalAuto || (isHomeowners && isIncludedFeaturesVisible),
                    model: getQuoteCoveragesVM(quoteVM.value),
                    showTooltip: true,
                    hideTooltipHeader: true,
                    useCoverageWrapperObj: true,
                    isHomeowners
                },
                [`viewIncludedFeaturesBtn${index}`]: {
                    content: isIncludedFeaturesVisible ? translator(messages.collapse) : translator(messages.viewAll)
                },
                [`customQuoteComponent${index}`]: {
                    submissionVM: submissionVM,
                    customQuote: quoteVM.value,
                    isAgent: true,
                    currentUser,
                    isDisplayOnly: forPostQuote || isQuoteLocked || isReadOnly(quoteVM),
                    isQuoteLocked,
                    isAlaska7Day,
                    baseData: _.get(submissionVM, 'baseData', {}),
                    hideEditLinks: false,
                    hideEditCoverage: false,
                    updateWizardData: updateWizardData,
                    lobPath: lobPathString,
                    isBundle,
                    prevIndex,
                    nextIndex,
                    isPrevAvailable,
                    isNextAvailable,
                    lineCoverageNamesMap,
                    vehicleCoverageNamesMap,
                    optionalCoverageNamesMap,
                    coverablesToDisplay,
                    updateMaps,
                    onPrevButtonClick,
                    onNextButtonClick,
                    updatePupLiabilityWarning: shouldShowPupLiabilityWarning,
                    setIsPUPPolicyRefreshed_Ext,
                    setUnderlyingPolicies,
                    termMonths,
                    navigateToStep,
                    refreshSelectedQuoteObj,
                    onAgentUpdatedCustomQuote: onUpdatedCustomQuote,
                    viewModelService
                },
                [`paDriverTablesComponent${index}`]: {
                    visible: isPersonalAuto,
                    submissionVM,
                    navigateToStep,
                    isAK7DayPolicy: () => { return isAlaska7Day; },
                    isGateway: true
                },
                [`numberOfDiscountsSpan${index}`]: {
                    content: _.get(quoteVM, 'value.discounts_ML.length')
                },
                [`discountsRepeat${index}`]: {
                    data: _.get(quoteVM, 'value.discounts_ML')
                },
                [`priorCarrierPremiumValue${index}`]: {
                    readOnly: forPostQuote || isQuoteLocked || isReadOnly(quoteVM),
                    onValueChange: writeValue
                },
                [`uwIssueContainer${index}`]: {
                    visible: _.get(quoteVM, 'value.uwIssues_ML.length' > 0),
                    uwIssues: _.get(quoteVM, 'value.uwIssues_ML'),
                    jobID: quoteID,
                    publicID: _.get(quoteVM, 'value.publicID'),
                    approvedAllQuoteBlockingUwIssuesCallback,
                    approvedAllBlockingUWIssuesCallback,
                    blockingUWIssuesPresentCallback,
                    submissionVM,
                    updateWizardData,
                    history
                },
                [`bookrollWarning${index}`]: {
                    visible: isBookrollBundleWithRateCapping
                },
                [`oecWarning${index}`]: {
                    visible: isOECWarningAvailable()
                },
                [`annualTermEligibleInfoDiv${index}`]: {
                    visible: isAnnualTermEligibleInfoAvailable()
                },

            };
        });
        return Object.assign({}, ...quoteOverrides);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [approvedAllBlockingUWIssuesCallback, approvedAllQuoteBlockingUwIssuesCallback, blockingUWIssuesPresentCallback, coverablesToDisplay, currentUser, customQuotes, disableProposalFields, forPostQuote, functionalReplacementCostError,
        getLiabilityLimitWarningMessageContent, getNameForMainButton, getPerTermLabel, getQuoteCoveragesVM, getTabHeader, history, isAlaska7Day, isBookroll, isBundle, isMainButtonDisabled, isNextAvailable, isPersonalAuto, isPersonalUmbrella,
        isPrevAvailable, isQuoteLocked, lineCoverageNamesMap, lobPathString, markQuoteStale, navigateToStep, nextIndex, onDeliveryPreferenceChange, onNextButtonClick, onPrevButtonClick, optionalCoverageNamesMap,
        prevIndex, quoteID, refreshSelectedQuoteObj, runMainButton, shouldShowPupLiabilityWarning, showPupLiabilityLimitWarning, submissionVM, termMonths, updateCustomQuote, updateMaps, updateQuotePayment, updateQuoteVM, updateWizardData,
        vehicleCoverageNamesMap, writeValue]);

    const overrideProps = {
        uwIssuesQuoteBlocking: {
            uwIssues: _.get(submissionVM, 'value.uwIssues_ML'),
            jobID: quoteID,
            rejectedIssuesAreQuoteBlocking: true,
            approvedAllBlockingUWIssuesCallback,
            submissionVM,
            history
        },
        autoStickyHeader: {
            visible: isPersonalAuto,
            selectedQuote: _.get(selectedQuoteVM, 'value', {}),
            prevIndex,
            nextIndex,
            isPrevAvailable,
            isNextAvailable,
            coverablesToDisplay,
            onPrevButtonClick,
            onNextButtonClick,
            navigateToStep,
            submissionVM,
            isQuoteLocked,
            forPostQuote,
            isBundle,
            isPurchasePolicyButton,
            canIssuePolicy,
            getNameForMainButton,
            mainButtonFunction: runMainButton,
            getPerTermLabel,
            isPolicyChange: false,
            hasValidationErrors,
            getQuoteCoverages,
            isMainButtonDisabled
        },
        commonStickyHeader: {
            visible: !isPersonalAuto,
            selectedQuote: _.get(selectedQuoteVM, 'value', {}),
            submissionVM,
            getNameForMainButton,
            mainButtonFunction: runMainButton,
            getPerTermLabel,
            isPolicyChange: false,
            hasValidationErrors,
            getQuoteCoverages,
            isMainButtonDisabled
        },
        quoteIterable: {
            data: customQuotes,
            activeTab: activeQuoteTab,
            defaultActiveTab: `${QUOTE_TAB_ID}${selectedQuoteIndex}quoteIterable`
        },
        addQuoteTabButton: {
            visible: (customQuotes.length < 3 && !isQuoteLocked) || (isModernProduct && customQuotes.length < 3 && !isQuoteLocked),
            heading: getAddQuoteTabHeading()
        },
        compareVersionButtonContainer: {
            visible: !isPersonalUmbrella && isMultiVersionCompareEnabled
        },
        compareVersionBtn: {
            disabled: offeredQuotes.length === 1,
            onClick: onCompareVersionClick
        },
        ...generateQuoteOverrides()
    };


    const skipOnResumeIf = useCallback(() => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value') && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }
        if(!_.isEmpty(_.get(submissionVM,'value.validationErrors_ML',[]))){
            return false
        }
        if(_.get(submissionVM,'value.baseData.status_ML','') === "Draft"){
            if(submissionVM.isBundle_ML.value  && (MLBundleService.isJobForPostQuote(submissionVM.quoteID.value) || MLBundleService.isJobPostQuoteStarted(submissionVM.quoteID.value) || MLBundleService.isJobPostQuoteComplete(submissionVM.quoteID.value))){
                // to remove it from purchase flow
                MLBundleService.resetPostQuoteStatusForJob(submissionVM.quoteID.value,authHeader)
                MLBundleService.resetPostQuoteStatusForAllJobs()
            }
            return false
        }
        return submissionVM.isBundle_ML.value && !stateParams?.returnToQuote && (MLBundleService.isJobForPostQuote(submissionVM.quoteID.value) || MLBundleService.isJobPostQuoteStarted(submissionVM.quoteID.value) || MLBundleService.isJobPostQuoteComplete(submissionVM.quoteID.value));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authHeader]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onQuoteTabChange,
            onToggleIncludedFeaturesSection: toggleIncludedFeaturesSection
        },
        resolveComponentMap: {
            mlquotepageproposalcomponent: MLQuotePageProposalComponent,
            mlagentquotestickyautocomponent: MLAgentQuoteStickyAutoComponent,
            quotepagedrivertablescomponent: QuotePageDriverTablesComponent,
            mlagentquotestickycomponent: MLAgentQuoteStickyComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent,
            MLAlertGroupComponent
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            skipWhen={skipOnResumeIf}
        >
            {isDiffPopupSelectorOpen && getVersionDiffPopup()}
            {isDiffPopupListOpen && getVersionDiffListPopup()}
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

GatewayQuotePage.propTypes = wizardProps;
export default withRouter(GatewayQuotePage);